import React, { useContext, useEffect, useState, useRef } from 'react'
import { dataContext, localestr, itemToText, toText, uid, loaddat, beginMn } from '../utils.js'
import EditCtrl from '../cmp/EditCtrl.js'
import UniTable from '../cmp/UniTable'
import FilterForm from '../cmp/FilterForm' //+
import Panel from '../cmp/Panel'
import Menu from '../cmp/menu'
import icon from '../icons.svg'

let loading = false

let buffer = ''
let timer = null
let findDlg = false
let findDlgProd = false

function DocRevisionEdit({ data, actions }) {
  const targetRef = useRef()
  let wndData = {}
  if (data) wndData = data.wndData
  else wndData = actions.getWndData()
  const tabNew = actions.tabNew
  const setWndData = actions.setWndData
  const tabClose = actions.tabClose
  const tblPos = actions.tblPos  //Таблиця
  const isActive = actions.isActive  //Таблиця
  const setGlData = actions.setGlData
  const getGlData = actions.getGlData

  const context = useContext(dataContext)
  const getData = context.getData
  //const saveData=context.saveData
  const addTWnd = context.addTWnd
  const msg = context.msg
  const loaddata = context.loaddata
  const inputNumber = context.inputNumber
  const inputWeight = context.inputWeight
  const getSettings = context.getSettings
  const setSettings = context.setSettings
  const usersettings = getSettings().docRevisionEdit;
  const inputCols = context.inputCols
  const msg_arr = context.msg_arr
  const setLoginData = context.setLoginData
  const urAdmin = parseInt((context.user || {}).urAdmin || 0)
  const posted = parseInt(wndData.posted || 0) && !urAdmin

  let balance = []
  if (wndData) balance = wndData.balance
  if (!balance) balance = []

  const selUnitType = context.data['selUnitType']
  const selectionType = getSettings().selectionType || '0'
  const catGoods = context.data['catGoods']

  //const [edit, setEdit] = useState(false)
  const edit = (getGlData() || {}).edit
  const setEdit = (d) => { setGlData({ edit: d }) }
  const editProd = (getGlData() || {}).editProd
  const setEditProd = (d) => { setGlData({ editProd: d }) }
  const [isActive2, setisActive] = useState(false)
  //const [activeTab, setActiveTab] = useState(0);
  const activeTab = wndData.activeTab || 0
  const setActiveTab = (d) => { setWndData({ ...wndData, activeTab: d }); if (d === 0) setGlData({ needFocus: 0 }); else setGlData({ needFocusProd: 0 }) }
  const cols = [
    { caption: '№', minWidth: '25', maxWidth: '30', dataId: 'docum', sortable: false, typeVal: 'submit', setFn: (d) => { saveValue(d) } },
    { caption: localestr('Товар'), minWidth: '70', dataId: 'good', sortable: true, typeVal: 'catGoods', setFn: (d) => { setVal('good', d) } },
    { caption: localestr('Минула інвентаризація'), colspan: 2, minWidth: '85', maxWidth: '90', dataId: 'rev_date', sortable: true },
    { caption: localestr('Кількість'), minWidth: '60', maxWidth: '80', dataId: 'sum_qtt_r', sortable: true },
    { caption: localestr('Од.'), minWidth: '30', maxWidth: '45', dataId: 'unit', sortable: true },
  ]
  if (wndData.department2 && wndData.department2.id) {
    cols.push({ caption: localestr('Факт. к-сть'), minWidth: '60', maxWidth: '95', dataId: 'sum_qtt_f', sortable: true, typeVal: 'number3', setFn: (d) => { setVal('sum_qtt_f', d) } },
      { caption: localestr('В продукції'), minWidth: '60', maxWidth: '95', dataId: 'sum_qtt_p', sortable: true, typeVal: 'number3', setFn: (d) => { setVal('sum_qtt_p', d) } },
      { caption: localestr('Облік. к-сть'), minWidth: '60', maxWidth: '95', dataId: 'sum_qtt_a', sortable: true, typeVal: 'number3', setFn: (d) => { setVal('sum_qtt_a', d) } },
      { caption: localestr('Різниця'), minWidth: '80', maxWidth: '110', dataId: 'sum_qtt', sortable: true, disabled: true },
      { caption: '2 ' + localestr('Факт.'), minWidth: '60', maxWidth: '95', dataId: 'sum_qtt2_f', sortable: true, typeVal: 'number3', setFn: (d) => { setVal('sum_qtt2_f', d) } },
      { caption: '2 ' + localestr('Облік.'), minWidth: '60', maxWidth: '95', dataId: 'sum_qtt2_a', sortable: true, typeVal: 'number3', setFn: (d) => { setVal('sum_qtt2_a', d) } },
      { caption: '2 ' + localestr('Різниця'), minWidth: '80', maxWidth: '110', dataId: 'sum_qtt2', sortable: true, disabled: true })
  } else {
    cols.push({ caption: localestr('Факт. к-сть'), minWidth: '60', maxWidth: '95', dataId: 'sum_qtt_f', sortable: true, typeVal: 'number3', setFn: (d) => { setVal('sum_qtt_f', d) } },
      { caption: localestr('В продукції'), minWidth: '60', maxWidth: '95', dataId: 'sum_qtt_p', sortable: true, typeVal: 'number3', setFn: (d) => { setVal('sum_qtt_p', d) } },
      { caption: localestr('Облік. к-сть'), minWidth: '60', maxWidth: '95', dataId: 'sum_qtt_a', sortable: true, typeVal: 'number3', setFn: (d) => { setVal('sum_qtt_a', d) } },
      { caption: localestr('Різниця'), minWidth: '80', maxWidth: '110', dataId: 'sum_qtt', sortable: true, disabled: true })
  }
  const cols_prod = [
    { caption: '№', minWidth: '20', maxWidth: '24', dataId: 'docum', sortable: false, typeVal: 'submit', setFn: () => { saveValueProd() } },
    { caption: localestr('Продукція'), minWidth: '70', dataId: 'good', sortable: true, typeVal: 'catGoods', setFn: (d) => { setVal('good', d, true) } },
    { caption: localestr('Минула інвентаризація'), colspan: 2, minWidth: '85', maxWidth: '90', dataId: 'rev_date', sortable: true },
    { caption: localestr('Кількість'), minWidth: '60', maxWidth: '80', dataId: 'sum_qtt_r', sortable: true },
    { caption: localestr('Од.'), minWidth: '30', maxWidth: '45', dataId: 'unit', sortable: true },
    //{caption:localestr('Факт. к-сть'),minWidth:'60',maxWidth:'95',dataId:'sum_qtt_f',sortable:true,typeVal:'number3',setFn:(d)=>{setVal('sum_qtt_f',d)}},
    { caption: localestr('В перерахунок'), minWidth: '100', maxWidth: '120', dataId: 'sum_qtt_f', sortable: true, typeVal: 'number3', setFn: (d) => { setVal('sum_qtt_f', d, true) } },
    //{caption:localestr('Облік. к-сть'),minWidth:'60',maxWidth:'95',dataId:'sum_qtt_a',sortable:true,typeVal:'number3',setFn:(d)=>{setVal('sum_qtt_a',d)}},
    //{caption:localestr('В перерахунок'),minWidth:'80',maxWidth:'110',dataId:'sum_qtt',sortable:true,disabled:true}
  ]

  if (usersettings && usersettings.cols) {
    for (let i = 0; i < usersettings.cols.length; i++) {
      const idx = cols.findIndex(el => el.dataId === usersettings.cols[i])
      if (idx !== -1) cols[idx].hiden = true
    }
  } else {
    cols[2].hiden = true
    cols[3].hiden = true
  }

  if (usersettings && usersettings.cols_prod) {
    for (let i = 0; i < usersettings.cols_prod.length; i++) {
      const idx = cols_prod.findIndex(el => el.dataId === usersettings.cols_prod[i])
      if (idx !== -1) cols_prod[idx].hiden = true
    }
  } else {
    cols_prod[2].hiden = true
    cols_prod[3].hiden = true
  }

  const filterData = [ //+
    { caption: localestr('Товар'), dataId: 'good', typeVal: 'catGoods' },
    { caption: localestr('Факт. к-сть'), dataId: 'sum_qtt_f', typeVal: 'number' },
    { caption: localestr('Облік. к-сть'), dataId: 'sum_qtt_a', typeVal: 'number' },
  ]
  if (wndData.department2 && wndData.department2.id) {
    filterData.push({ caption: '2 ' + localestr('Факт.'), dataId: 'sum_qtt2_f', typeVal: 'number' },
      { caption: '2 ' + localestr('Облік.'), dataId: 'sum_qtt2_a', typeVal: 'number' })
  }

  const setFilter = (id, val, type) => {
    let filter = [...(wndData.filter || [])]
    const idx = filter.findIndex(el => el.dataId === id)
    if (idx !== -1) {
      if (!val) filter.splice(idx, 1)
      else filter[idx].value = val
    } else if (val) filter.push({ dataId: id, compare: 'lk', value: val, typeVal: type })
    if (!filter.length) filter = undefined
    setWndData({ ...wndData, filter, currentCol: undefined })
    setGlData({ needFocus: 1 })
    tblPos(0)
  }

  const setFilter_prod = (id, val, type) => {
    let filter_prod = [...(wndData.filter_prod || [])];
    const idx = filter_prod.findIndex(el => el.dataId === id);
    if (idx !== -1) {
      if (!val) filter_prod.splice(idx, 1);
      else filter_prod[idx].value = val;
    } else if (val) {
      filter_prod.push({ dataId: id, compare: 'lk', value: val, typeVal: type });
    }
    if (!filter_prod.length) filter_prod = undefined;
    setWndData({ ...wndData, filter_prod });
  };

  const showHideFilter = (prod = false) => {
    const filterKey = prod ? 'filter_prod' : 'filter';
    const showFilterKey = prod ? 'showAFilter_prod' : 'showAFilter';
    const showFilter = !wndData[showFilterKey];
    setWndData({
      ...wndData,
      [showFilterKey]: showFilter,
      [filterKey]: showFilter ? wndData[filterKey] : undefined
    });
  };

  const listFromData = (currentCol, setCurrCol) => {
    let balance = []
    if (wndData.balance) balance = wndData.balance
    let list = []
    let prod_list = []
    //if (wndData.table) list=wndData.table.map((item)=>{
    if (wndData.table) wndData.table.forEach((item) => {
      const newItem = {
        uid: uid(),
        id: item.id,
        good: { id: item.good_id, name: item.good, parent: { id: item.good_pid }, type: parseInt(item.good_type) || 0, obj_type: 'catGoods' },
        unit: selUnitType.find(x => x.value === item.unit),
        sum_qtt_f: parseFloat(item.qtt_f || 0).toFixed(3),
        sum_qtt_p: parseFloat(item.qtt_p || 0).toFixed(3),
        sum_qtt_a: parseFloat(item.qtt_a || 0).toFixed(3),
        sum_qtt: (parseFloat(item.qtt_f || 0) + parseFloat(item.qtt_p || 0) - parseFloat(item.qtt_a || 0)).toFixed(3),
        sum_qtt2_f: parseFloat(item.qtt2_f || 0).toFixed(3),
        sum_qtt2_a: parseFloat(item.qtt2_a || 0).toFixed(3),
        sum_qtt2: (parseFloat(item.qtt2_f || 0) - parseFloat(item.qtt2_a || 0)).toFixed(3),
        sum_qtt_r: ''
      }
      const idx = balance.findIndex(x => x.good === parseInt(item.good_id))
      if (idx !== -1) {
        if (balance[idx].rev_date) newItem.rev_date = balance[idx].rev_date
        if (balance[idx].rev_qtt) newItem.sum_qtt_r = balance[idx].rev_qtt
      }
      if (item.edit) newItem.edit = true
      if (typeof currentCol !== 'undefined' && currentCol.id === item.id) setCurrCol(newItem)
      if (newItem.good.type > 1 && parseFloat(item.qtt_f || 0) + parseFloat(item.qtt_p || 0) === 0 && parseFloat(item.qtt_a || 0) === 0) prod_list.push({ ...newItem, product: true })
      else list.push(newItem)
      //return newItem
    })
    return [list, prod_list]
  }

  const sortList = (col, sort, list, prod_list) => {
    let needUpd = false
    let currentCol = wndData.currentCol
    if (!prod_list) prod_list = wndData.prod_list
    if (typeof list === 'undefined') { [list, prod_list] = listFromData(currentCol, newCol => currentCol = newCol); needUpd = true }
    else if (typeof wndData.list === 'undefined') { [list, prod_list] = listFromData(currentCol, newCol => currentCol = newCol); needUpd = true }
    else list = wndData.list.slice()

    list.sort((a, b) => {
      let vala = toText(a[col])
      let valb = toText(b[col])
      if (col === 'id') {
        vala = parseInt(vala)
        valb = parseInt(valb)
      } else if (col === 'date') {
        vala = (a[col])
        valb = (b[col])
      } else if (col.substring(0, 4) === 'sum_') {
        vala = parseFloat(a[col] || 0)
        valb = parseFloat(b[col] || 0)
      } else {
        vala = (vala || '').toLowerCase()
        valb = (valb || '').toLowerCase()
      }
      if (sort === 'asc') {
        if (vala < valb) { needUpd = true; return -1 }
        if (vala > valb) return 1
        return 0
      } else if (sort === 'desc') {
        if (vala < valb) return 1
        if (vala > valb) { needUpd = true; return -1 }
        return 0
      } else return 0
    })
    const sorting = { dataId: col, sort: sort }
    if (needUpd || wndData.sorting.dataId !== col || wndData.sorting.sort !== sort) setWndData({ ...wndData, list, prod_list, sorting, currentCol })
  }

  const sortList_prod = (col, sort, prod_list, list) => {
    let needUpd = false
    let currentCol = wndData.currentCol
    if (typeof prod_list === 'undefined') { [list, prod_list] = listFromData(currentCol, newCol => currentCol = newCol); needUpd = true }
    else if (typeof wndData.list === 'undefined') { [list, prod_list] = listFromData(currentCol, newCol => currentCol = newCol); needUpd = true }
    else prod_list = wndData.prod_list.slice()

    prod_list.sort((a, b) => {
      let vala = toText(a[col])
      let valb = toText(b[col])
      if (col === 'id') {
        vala = parseInt(vala)
        valb = parseInt(valb)
      } else if (col === 'date') {
        vala = (a[col])
        valb = (b[col])
      } else if (col.substring(0, 4) === 'sum_') {
        vala = parseFloat(a[col] || 0)
        valb = parseFloat(b[col] || 0)
      } else {
        vala = (vala || '').toLowerCase()
        valb = (valb || '').toLowerCase()
      }
      if (sort === 'asc') {
        if (vala < valb) { needUpd = true; return -1 }
        if (vala > valb) return 1
        return 0
      } else if (sort === 'desc') {
        if (vala < valb) return 1
        if (vala > valb) { needUpd = true; return -1 }
        return 0
      } else return 0
    })
    const sorting_prod = { dataId: col, sort: sort }
    if (needUpd || wndData.sorting_prod.dataId !== col || wndData.sorting_prod.sort !== sort) setWndData({ ...wndData, prod_list, sorting_prod, currentCol })
  }

  const setHidenCols = (data, prod = false) => {
    if (data) {
      const new_cols = data.filter(el => el.hiden).map(el => el.dataId);
      const new_data = usersettings || {}
      if (prod) new_data.cols_prod = new_cols
      else new_data.cols = new_cols
      setSettings({ docRevisionEdit: { ...new_data } });
    } else {
      if (edit) return;
      if (editProd) return;
      const currentTable = prod ? [...cols_prod] : [...cols];
      inputCols(currentTable, (newData) => setHidenCols(newData, prod));
    }
  }

  const setCol = (currentCol) => {
    if (!posted) setisActive(true)
    if (wndData.currentCol) if (currentCol.uid === wndData.currentCol.uid) return
    if ((getGlData() || {}).edit) { saveValue(() => { setCol(currentCol) }); return }
    //const list=wndData.list
    //const sorting=wndData.sorting
    //setWndData({...wndData,currentCol})
    const oldCol = { ...currentCol }
    //setWndData({...wndData,currentCol,oldCol,currentColProd:undefined})
    setWndData({ ...wndData, currentCol, oldCol })
    setGlData({ needFocus: 0 })
  }

  const setColProd = (currentColProd) => {
    if (!posted) setisActive(true)
    if (wndData.currentColProd) if (currentColProd.uid === wndData.currentColProd.uid) return
    if ((getGlData() || {}).editProd) { saveValueProd(() => { setCol(currentColProd) }); return }
    //if (edit) return
    //setisActive(true)
    //const list=wndData.list
    //const sorting=wndData.sorting
    const oldColProd = { ...currentColProd }
    //setWndData({...wndData,currentColProd:currentColProd,oldColProd,currentCol:undefined})
    setWndData({ ...wndData, currentColProd: currentColProd, oldColProd })
    setGlData({ needFocusProd: 0 })
  }

  const setVal = (name, data, prod = false) => {
    let currentCol = wndData.currentCol
    if (prod) currentCol = wndData.currentColProd
    //if(name==='sum_qtt_w') name='sum_qtt'
    currentCol[name] = data
    if (name === 'good') {
      let balance = []
      if (wndData.balance) balance = wndData.balance
      const selUnitType = context.data['selUnitType']
      const qtt_f = parseFloat(currentCol.sum_qtt_f || 1)
      const qtt2_f = parseFloat(currentCol.sum_qtt2_f || 0)
      let qtt_a = 0
      let qtt_p = 0
      let qtt2_a = 0
      currentCol.rev_date = ''
      currentCol.sum_qtt_r = ''
      const idx = balance.findIndex(x => x.good === parseInt(data.id))
      if (idx !== -1) {
        if (balance[idx].rev_date) currentCol.rev_date = balance[idx].rev_date
        if (balance[idx].rev_qtt) currentCol.sum_qtt_r = balance[idx].rev_qtt
        if (wndData.department2 && wndData.department2.id) {
          const idx1 = balance[idx].deps.findIndex(x => parseInt(x.dep) === parseInt(wndData.department.id))
          const idx2 = balance[idx].deps.findIndex(x => parseInt(x.dep) === parseInt(wndData.department2.id))
          if (idx1 !== -1) qtt_a = balance[idx].deps[idx1].qtt
          if (idx2 !== -1) qtt2_a = balance[idx].deps[idx2].qtt
        } else qtt_a = balance[idx].qtt
      }
      if (typeof data.unit === 'object') currentCol.unit = data.unit
      else currentCol.unit = selUnitType.find(x => x.value === data.unit)
      currentCol.sum_qtt_f = qtt_f.toFixed(3)
      currentCol.sum_qtt_p = qtt_p.toFixed(3)
      currentCol.sum_qtt_a = qtt_a.toFixed(3)
      currentCol.sum_qtt = (qtt_f - qtt_a).toFixed(3)
      currentCol.sum_qtt2_f = qtt2_f.toFixed(3)
      currentCol.sum_qtt2_a = qtt2_a.toFixed(3)
      currentCol.sum_qtt2 = (qtt2_f - qtt2_a).toFixed(3)
    } else if (name === 'sum_qtt_f' || name === 'sum_qtt_p' || name === 'sum_qtt_a') {
      const qtt_f = parseFloat(currentCol.sum_qtt_f) || 0
      const qtt_p = parseFloat(currentCol.sum_qtt_p) || 0
      const qtt_a = parseFloat(currentCol.sum_qtt_a) || 0
      currentCol.sum_qtt = (qtt_f + qtt_p - qtt_a).toFixed(3)
    } else if (name === 'sum_qtt2_f' || name === 'sum_qtt2_a') {
      const qtt_f = parseFloat(currentCol.sum_qtt2_f) || 0
      const qtt_a = parseFloat(currentCol.sum_qtt2_a) || 0
      currentCol.sum_qtt2 = (qtt_f - qtt_a).toFixed(3)
    }
    if (prod) { setWndData({ ...wndData, currentColProd: currentCol }); setEditProd(true) }
    else { setWndData({ ...wndData, currentCol }); setEdit(true) }

  }

  /*const cancelEdit=()=>{
      const newData=actions.getWndData()
      if(newData.oldCol){
          newData.currentCol={...newData.oldCol}
          newData.oldCol=undefined
          newData.list=newData.list.map(el=>el.uid!==newData.currentCol.uid?el:{...newData.currentCol})
          
      } else {
          const list=newData.list.filter(el=>el.uid!==newData.currentCol.uid)
          setWndData({...wndData,list,currentCol:undefined,oldCol:undefined})
      }
      setTimeout(()=>setEdit(false),200)
  }*/
  const cancelEdit = () => {
    if (!isActive()) return
    setEdit(false)
    setisActive(false)
    setGlData({ lastCol: 0, needFocus: 0 })
    const newData = actions.getWndData()
    if (newData.oldCol) {
      newData.currentCol = { ...newData.oldCol }
      newData.oldCol = undefined
      newData.list = newData.list.map(el => el.uid !== newData.currentCol.uid ? el : { ...newData.currentCol })
      setWndData(newData)
    } else {
      const list = newData.list.filter(el => el.uid !== newData.currentCol.uid)
      setWndData({ ...wndData, list, currentCol: undefined, oldCol: undefined })
    }
  }

  const cancelEditProd = () => {
    if (!isActive()) return
    setEditProd(false)
    setisActive(false)
    setGlData({ lastColProd: 0, needFocusProd: 0 })
    const newData = actions.getWndData()
    if (newData.oldColProd) {
      newData.currentColProd = { ...newData.oldColProd }
      newData.oldColProd = undefined
      newData.prod_list = newData.prod_list.map(el => el.uid !== newData.currentColProd.uid ? el : { ...newData.currentColProd })

    } else {
      const prod_list = newData.prod_list.filter(el => el.uid !== newData.currentColProd.uid)
      setWndData({ ...wndData, prod_list, currentColProd: undefined, oldColProd: undefined })
    }
  }

  const tblPosProd = (data = null) => { //для позиціонування скрола в таблиці
    const posProd = (getGlData() || {}).posProd
    if (data !== null) { setGlData({ posProd: data }); return data }
    else return posProd || 0
  }

  const filter = (fltr) => {
    let showFilter = !wndData.showFilter
    let filter = wndData.filter
    if (fltr !== undefined) filter = fltr
    if (showFilter || fltr === undefined) setWndData({ ...wndData, showFilter, filter })
    else {
      setWndData({ ...wndData, showFilter, filter, currentCol: undefined })
      setGlData({ needFocus: 1 })
      tblPos(0)
    }
  }

  const filter_prod = (fltr) => {
    let showFilter_prod = !wndData.showFilter_prod;
    let filter_prod = wndData.filter_prod;
    if (fltr !== undefined) filter_prod = fltr;
    if (showFilter_prod || fltr === undefined) setWndData({ ...wndData, showFilter_prod, filter_prod })
    else {
      setWndData({ ...wndData, showFilter_prod, filter_prod })
      setGlData({ needFocusProd: 1 })
      tblPosProd(0)
    }
  }

  const setValue = (name, data) => {
    if (posted) return
    setisActive(false)
    let newData = { ...wndData }
    // перевірити чи дата у минулому більше за 90 днів
    // перевірити чи дата у майбутньому
    if (name === 'date') {
      const currentDay = new Date();
      currentDay.setHours(23, 59, 59, 99);
      const inputDay = new Date(data);
      if (inputDay > currentDay) msg(localestr("Цей день ще не настав!"), localestr('Попередження'), [{ caption: 'OK', action: () => { } }]);
      else if ((currentDay - inputDay) / (1000 * 60 * 60 * 24) > 90) msg(localestr("У вас дуже стара дата!"), localestr('Попередження'), [{ caption: 'OK', action: () => { } }]);
    }
    if (data === '') newData[name] = null
    else newData[name] = data
    if (!newData.edit) newData.edit = true
    setWndData(newData, true)
    if (name === 'date' || name === 'department' || name === 'department2') {
      if (newData.department && newData.department.id && newData.department2 && newData.department2.id) loaddat('action=balGoodsRev&data=' + (new Date(newData.date)).toISOString() + '&dep=' + newData.department.id + '-' + newData.department2.id, (dt) => { loadData(dt); fillDoc() })
      else if (newData.department && newData.department.id) loaddat('action=balGoodsRev&data=' + (new Date(newData.date)).toISOString() + '&dep=' + newData.department.id, (dt) => { loadData(dt); fillDoc() })
      else loaddat('action=balGoodsRev&data=' + (new Date(newData.date)).toISOString(), (dt) => { loadData(dt, fillDoc)/*;fillDoc()*/ })
    }
  }

  const saveValue = (act = null) => {
    if (!isActive()) return
    let errmsg = ''
    if (!wndData.currentCol) return
    const currCol = { ...wndData.currentCol, edit: true }
    const list = wndData.list
    if (!currCol.good) errmsg = localestr("Не заповнено товар")
    else {
      let idx = list.findIndex(m => m.good && m.good.id === currCol.good.id && m.uid !== currCol.uid && !m.hide)
      if (idx !== -1) errmsg = localestr("Товар") + " " + currCol.good.name + " " + localestr("дублюється в рядку") + " " + (idx + 1)
    }
    //if (!currCol.sum_qtt_f) currCol.sum_qtt_f=null
    if (errmsg !== '') { msg(errmsg, localestr('Помилка'), [{ caption: 'OK', action: () => { } }]); return }
    else {
      /*if(q&&parseInt(currCol.good.type)>1){
          errmsg=localestr("Продукція та напівфабрикати мають бути у другій таблиці.\nТоді інгредієнти, які входять до їх складу, будуть\nвраховані у кількості товарів. В цій таблиці продукція чи\nнапівфабрикати будуть рахуватися як звичайні товари.")
          msg(errmsg,localestr('Помилка'),[{caption:localestr('Залишити тут'),action:()=>saveValue(false)},{caption:localestr('Відмінити'),action:()=>{}}])
          return
      }*/
      currCol.sum_qtt_f = (parseFloat(currCol.sum_qtt_f) || 0).toFixed(3)
      currCol.sum_qtt_p = (parseFloat(currCol.sum_qtt_p) || 0).toFixed(3)
      currCol.sum_qtt_a = (parseFloat(currCol.sum_qtt_a) || 0).toFixed(3)
      currCol.sum_qtt = (parseFloat(currCol.sum_qtt_f || 0) + (parseFloat(currCol.sum_qtt_p) || 0) - (parseFloat(currCol.sum_qtt_a) || 0)).toFixed(3)
      currCol.sum_qtt2_f = (parseFloat(currCol.sum_qtt2_f) || 0).toFixed(3)
      currCol.sum_qtt2_a = (parseFloat(currCol.sum_qtt2_a) || 0).toFixed(3)
      currCol.sum_qtt2 = (parseFloat(currCol.sum_qtt2) || 0).toFixed(3)
      const idx = list.findIndex(el => el.uid === currCol.uid)
      if (idx === -1) list.push(currCol)
      else list[idx] = currCol
      let newData = { ...wndData, list }
      setWndData(newData, true)
      setEdit(false)
      setisActive(false)
      if (act === -1) setGlData({ lastCol: 0, needFocus: 0 })
      else if (act) setTimeout(() => { act() }, 100)
    }
  }

  const saveValueProd = (act = null) => {
    if (!isActive()) return
    let errmsg = ''
    const currCol = { ...wndData.currentColProd, edit: true }
    const prod_list = wndData.prod_list
    if (!currCol) return
    if (!currCol.good) errmsg = localestr("Не заповнено продукцію")
    else if (parseInt(currCol.good.type) < 2) errmsg = localestr("Це товар, а не продукція чи напівфабрткат.\nТовари мають бути у першій таблиці.")
    //if (!currCol.sum_qtt_f) currCol.sum_qtt_f=null
    if (errmsg !== '') { msg(errmsg, localestr('Помилка'), [{ caption: 'OK', action: () => { } }]); return }
    else {
      currCol.sum_qtt_f = parseFloat(currCol.sum_qtt_f || 0).toFixed(3)
      currCol.sum_qtt_p = parseFloat(currCol.sum_qtt_p || 0).toFixed(3)
      //currCol.sum_qtt_a=parseFloat(currCol.sum_qtt_a||0).toFixed(3)
      currCol.sum_qtt_a = '0.000'
      //currCol.sum_qtt=(parseFloat(currCol.sum_qtt_f||0)-parseFloat(currCol.sum_qtt_a||0)).toFixed(3)
      currCol.sum_qtt = '0.000'
      currCol.sum_qtt2_f = parseFloat(currCol.sum_qtt2_f || 0).toFixed(3)
      //currCol.sum_qtt2_a=parseFloat(currCol.sum_qtt2_a||0).toFixed(3)
      currCol.sum_qtt2_a = '0.000'
      //currCol.sum_qtt2=parseFloat(currCol.sum_qtt2||0).toFixed(3)
      currCol.sum_qtt2 = '0.000'
      const idx = prod_list.findIndex(el => el.uid === currCol.uid)
      if (idx === -1) prod_list.push(currCol)
      else prod_list[idx] = currCol
      const list = calculate_ing(wndData.list, prod_list)
      let newData = { ...wndData, list, prod_list }
      setWndData(newData, true)
      setEditProd(false)
      setisActive(false)
      if (act === -1) setGlData({ lastColProd: 0, needFocusProd: 0 })
      else if (act) setTimeout(() => { act() }, 100)
      //setTimeout(()=>setEdit(false),200)
    }
  }

  const newItem = () => {
    if (posted) return
    if ((getGlData() || {}).edit) { saveValue(() => { newItem() }); return }
    //if (edit) return
    setisActive(true)
    let currentCol = { id: '', uid: uid() }
    const list = wndData.list.concat(currentCol)
    setWndData({ ...wndData, list, currentCol })
    setGlData({ lastCol: 0, needFocus: 0 })
    setEdit(true)
  }

  const newItemProd = () => {
    if (posted) return
    if ((getGlData() || {}).editProd) { saveValueProd(() => { newItemProd() }); return }
    //if (edit) return
    setisActive(true)
    let currentColProd = { id: '', uid: uid(), product: true }
    const prod_list = (wndData.prod_list || []).concat(currentColProd)
    setWndData({ ...wndData, prod_list, currentColProd, currentCol: undefined })
    setGlData({ lastColProd: 0, needFocusProd: 0 })
    setEditProd(true)
  }

  /*const copyItem=()=>{
      if(posted) return
      if (edit) return
      if (typeof wndData.currentCol === 'object') {
          let currentCol={...wndData.currentCol,uid:uid()}
          delete currentCol.id
          const list=wndData.list.concat(currentCol)
          setWndData({...wndData,list,currentCol,currentColProd:undefined})
          setEdit(true)
      }
  }*/
  const copyItem = () => {
    if (posted) return
    if ((getGlData() || {}).edit) { saveValue(() => { copyItem() }); return }
    //if (edit) return
    if (typeof wndData.currentCol === 'object') {
      setisActive(true)
      let currentCol = { ...wndData.currentCol, uid: uid() }
      delete currentCol.id
      const list = wndData.list.concat(currentCol)
      setWndData({ ...wndData, list, currentCol })
      setGlData({ needFocus: 0, lastCol: 0 })
      setEdit(true)
    }
  }

  const editItem = () => {
    return
    /*if(posted) return
    if (edit) return
    if (!wndData.currentCol) return
    const currentCol={...wndData.currentCol}
    const oldCol={...wndData.currentCol}
    setWndData({...wndData,currentCol,oldCol})
    setEdit(true)*/
  }

  const editItemProd = () => {
    return
    /*if(posted) return
    if (edit) return
    if (!wndData.currentColProd) return
    const currentColProd={...wndData.currentColProd}
    const oldColProd={...wndData.currentColProd}
    setWndData({...wndData,currentColProd,oldColProd,currentCol:undefined})
    setEdit(true)*/
  }

  const editClick = () => {
    if (typeof wndData.currentCol === 'object') editItem()
  }

  const selectionClick = (fld = 2) => {
    if (posted) return
    if ((getGlData() || {}).edit) { saveValue(() => { selectionClick() }); return }
    let curVall = undefined
    if (wndData.currentCol) curVall = wndData.currentCol.menu
    if (!curVall) addTWnd(localestr('Вибір'), 'catGoods_list', selectionProc, undefined, undefined, fld)
    else if (curVall.parent) addTWnd(localestr('Вибір'), 'catGoods_list', selectionProc, curVall, curVall.parent, fld)
    else addTWnd('Вибір', 'catGoods_list', selectionProc, curVall, undefined, fld)
  }

  const add_folder = (e) => {
    if (posted) return
    const selUnitType = context.data['selUnitType']
    //вибрати всі товари підлеглі папці і додати в док
    let arrGoods = context.data['catGoods']
    if (arrGoods) arrGoods = arrGoods.filter(el => el.parent.id === e.id)
    else arrGoods = []
    arrGoods.forEach(item => selectionProc({ ...item, good_type: parseInt(item.type), sum_bal: '', unit: selUnitType.find(x => x.value === item.unit) }, 0.0001, 0))
    //вибрати всі підлеглі папки і для кожної викликати себе рекурсивно
    let arrFolders = context.data['fldGoods']
    if (arrFolders) arrFolders = arrFolders.filter(el => el.parent.id === e.id)
    else arrFolders = []
    arrFolders.forEach(item => add_folder(item))
  }

  const selectionProc = (e, qtt, qtt2) => {
    console.log('selectionProc')
    if (posted) return
    if ((getGlData() || {}).edit) { saveValue(() => { selectionProc(e, qtt, qtt2) }); return }
    if (e.isfolder) { add_folder(e); return }
    //менюшка з вибором або в константах чи локально Тихий режим, Запитувати кількість, Запитувати кількість і ціну, Запитувати кількість і суму
    if ((qtt === undefined || qtt === null) && parseInt(selectionType) > 0) {
      if (e.unit && (e.unit.value === '2' || e.unit === '2')) inputWeight(localestr('Кількість'), localestr('Кількість'), 1, (d) => { selectionProc(e, parseFloat(d || 0)) })
      else inputNumber(localestr('Кількість'), localestr('Кількість'), 1, (d) => { selectionProc(e, parseFloat(d || 0)) })
      return
    }
    if (!qtt) qtt = 0
    if (wndData.department2 && wndData.department2.id && (qtt2 === undefined || qtt2 === null) && parseInt(selectionType) > 0) {
      if (e.unit && (e.unit.value === '2' || e.unit === '2')) inputWeight(localestr('Кількість'), localestr('Кількість'), 1, (d) => { selectionProc(e, qtt, parseFloat(d || 0)) })
      else inputNumber(localestr('Кількість2'), localestr('Кількість2'), 1, (d) => { selectionProc(e, qtt, parseFloat(d || 0)) })
      return
    }
    if (!qtt2) qtt2 = 0
    let newData = { ...wndData, findText: '', findArr: null, findTextProd: '', findArrProd: null }
    let list = newData.list
    let prod_list = newData.prod_list
    const good_type = parseInt(e.type || 1)
    if (good_type > 1) {
      let el = prod_list.find(m => m.good?.id === e.id)
      if (!el) {
        let qtt_a = 0
        let qtt2_a = 0
        const idx = balance.findIndex(x => x.good === parseInt(e.id))
        if (idx !== -1) {
          if (wndData.department2 && wndData.department2.id) {
            const idx1 = balance[idx].deps.findIndex(x => parseInt(x.dep) === parseInt(wndData.department.id))
            const idx2 = balance[idx].deps.findIndex(x => parseInt(x.dep) === parseInt(wndData.department2.id))
            if (idx1 !== -1) qtt_a = balance[idx].deps[idx1].qtt
            if (idx2 !== -1) qtt2_a = balance[idx].deps[idx2].qtt
          } else qtt_a = balance[idx].qtt
        }
        el = {
          uid: uid(),
          good: { ...e },
          unit: e.unit,
          sum_qtt_f: qtt.toFixed(3),
          sum_qtt_a: qtt_a.toFixed(3),
          sum_qtt: (qtt - qtt_a).toFixed(3),
          sum_qtt2_f: qtt2.toFixed(3),
          sum_qtt2_a: qtt2_a.toFixed(3),
          sum_qtt2: (qtt2 - qtt2_a).toFixed(3),
          product: true,
          edit: true
        }
        if (idx !== -1) {
          if (balance[idx].rev_date) el.rev_date = balance[idx].rev_date
          if (balance[idx].rev_qtt) el.sum_qtt_r = balance[idx].rev_qtt
        }
        if (typeof (el.unit) !== 'object') el.unit = selUnitType.find(x => x.value === el.unit)
        if (qtt_a === 0 && qtt2_a === 0) prod_list.push(el)
        else {
          let el_good = list.find(m => m.good.id === e.id)
          if (!el_good) list.push(el)
          else if (el_good.hide) {
            const sum_qtt_f = qtt
            const sum_qtt2_f = qtt2
            const qtt_a = parseFloat(el_good.sum_qtt_a)
            const qtt2_a = parseFloat(el_good.sum_qtt2_a)
            el_good.sum_qtt_f = sum_qtt_f.toFixed(3)
            el_good.sum_qtt = (qtt - qtt_a).toFixed(3)
            el_good.sum_qtt2_f = sum_qtt2_f.toFixed(3)
            el_good.sum_qtt2 = (qtt2 - qtt2_a).toFixed(3)
            el_good.hide = false
            el_good.edit = true
          } else {
            const sum_qtt_f = parseFloat(el_good.sum_qtt_f || 0) + qtt
            const sum_qtt2_f = parseFloat(el_good.sum_qtt2_f || 0) + qtt2
            const qtt_a = parseFloat(el_good.sum_qtt_a)
            const qtt2_a = parseFloat(el_good.sum_qtt2_a)
            el_good.sum_qtt_f = sum_qtt_f.toFixed(3)
            el_good.sum_qtt = (sum_qtt_f - qtt_a).toFixed(3)
            el_good.sum_qtt2_f = sum_qtt2_f.toFixed(3)
            el_good.sum_qtt2 = (sum_qtt2_f - qtt2_a).toFixed(3)
            //el.sum_amount=''
            el_good.edit = true
          }
          setTimeout(() => msg(e.name + ' ' + localestr('має залишки по обліку. Його додано у першу таблицю як звичайний товар!'), localestr('Повідомлення'), [{ caption: 'OK', action: () => { } }]), 300)
        }
      } else if (el.hide) {
        const sum_qtt_f = qtt
        const sum_qtt2_f = qtt2
        const qtt_a = parseFloat(el.sum_qtt_a)
        const qtt2_a = parseFloat(el.sum_qtt2_a)
        el.sum_qtt_f = sum_qtt_f.toFixed(3)
        el.sum_qtt = (qtt - qtt_a).toFixed(3)
        el.sum_qtt2_f = sum_qtt2_f.toFixed(3)
        el.sum_qtt2 = (qtt2 - qtt2_a).toFixed(3)
        el.hide = false
        el.edit = true
      } else {
        const sum_qtt_f = parseFloat(el.sum_qtt_f || 0) + qtt
        const sum_qtt2_f = parseFloat(el.sum_qtt2_f || 0) + qtt2
        const qtt_a = parseFloat(el.sum_qtt_a)
        const qtt2_a = parseFloat(el.sum_qtt2_a)
        el.sum_qtt_f = sum_qtt_f.toFixed(3)
        el.sum_qtt = (sum_qtt_f - qtt_a).toFixed(3)
        el.sum_qtt2_f = sum_qtt2_f.toFixed(3)
        el.sum_qtt2 = (sum_qtt2_f - qtt2_a).toFixed(3)
        //el.sum_amount=''
        el.edit = true
      }
      newData.currentColProd = { ...el }
      newData.currentCol = undefined
      list = calculate_ing(list, prod_list)
    } else {
      let el = list.find(m => m.good.id === e.id)
      if (!el) {
        let qtt_a = 0
        let qtt2_a = 0
        const idx = balance.findIndex(x => x.good === parseInt(e.id))
        if (idx !== -1) {
          if (wndData.department2 && wndData.department2.id) {
            const idx1 = balance[idx].deps.findIndex(x => parseInt(x.dep) === parseInt(wndData.department.id))
            const idx2 = balance[idx].deps.findIndex(x => parseInt(x.dep) === parseInt(wndData.department2.id))
            if (idx1 !== -1) qtt_a = balance[idx].deps[idx1].qtt
            if (idx2 !== -1) qtt2_a = balance[idx].deps[idx2].qtt
          } else qtt_a = balance[idx].qtt
        }
        el = {
          uid: uid(),
          good: { ...e },
          unit: e.unit,
          sum_qtt_f: qtt.toFixed(3),
          sum_qtt_a: qtt_a.toFixed(3),
          sum_qtt: (qtt - qtt_a).toFixed(3),
          sum_qtt2_f: qtt2.toFixed(3),
          sum_qtt2_a: qtt2_a.toFixed(3),
          sum_qtt2: (qtt2 - qtt2_a).toFixed(3),
          edit: true
        }
        if (idx !== -1) {
          if (balance[idx].rev_date) el.rev_date = balance[idx].rev_date
          if (balance[idx].rev_qtt) el.sum_qtt_r = balance[idx].rev_qtt
        }
        if (typeof (el.unit) !== 'object') el.unit = selUnitType.find(x => x.value === el.unit)
        list.push(el)
      } else if (el.hide) {
        const sum_qtt_f = qtt
        const sum_qtt2_f = qtt2
        const qtt_a = parseFloat(el.sum_qtt_a)
        const qtt2_a = parseFloat(el.sum_qtt2_a)
        el.sum_qtt_f = sum_qtt_f.toFixed(3)
        el.sum_qtt = (qtt - qtt_a).toFixed(3)
        el.sum_qtt2_f = sum_qtt2_f.toFixed(3)
        el.sum_qtt2 = (qtt2 - qtt2_a).toFixed(3)
        el.hide = false
        el.edit = true
      } else {
        console.log(el.sum_qtt_f)
        const sum_qtt_f = parseFloat(el.sum_qtt_f || 0) + qtt
        const sum_qtt2_f = parseFloat(el.sum_qtt2_f || 0) + qtt2
        const qtt_a = parseFloat(el.sum_qtt_a)
        const qtt2_a = parseFloat(el.sum_qtt2_a)
        el.sum_qtt_f = sum_qtt_f.toFixed(3)
        el.sum_qtt = (sum_qtt_f - qtt_a).toFixed(3)
        el.sum_qtt2_f = sum_qtt2_f.toFixed(3)
        el.sum_qtt2 = (sum_qtt2_f - qtt2_a).toFixed(3)
        //el.sum_amount=''
        el.edit = true
        console.log(el.sum_qtt_f)

      }
      newData.currentCol = { ...el }
    }
    newData.list = list
    newData.prod_list = prod_list
    if (newData.currFind !== undefined) {
      newData.currFind = undefined
      //Тут фокусування на пошуку 'search'
      setTimeout(() => {
        const el = document.getElementById('search')
        if (el) el.focus()
      }, 200)
    }
    setWndData(newData, true)
    setGlData({ needFocus: -2, lastCol: 0 })
  }

  const removeItem = (q = true) => {
    if (posted) return
    //if (edit) return
    if ((getGlData() || {}).edit) { saveValue(() => { removeItem() }); return }
    if (!wndData.currentCol) return
    const currCol = { ...wndData.currentCol, edit: true, hide: true }
    if (q) {
      if (parseFloat(currCol.sum_qtt_p)) {
        msg(localestr("Буде видалено товар, який входить до складу продукції.\nПри перерахунку інгредієнтів у продукції він з'явиться знову.\nПродовжити?"),
          localestr('Попередження'), [{ caption: 'OK', action: () => { removeItem(false) } }, { caption: 'Відміна', action: () => { } }])
        return
      }
    }
    const list = wndData.list
    const idx = list.findIndex(el => el.uid === currCol.uid)
    if (idx === -1) return
    list[idx] = currCol
    let curIdx = idx + 1
    let currentCol = undefined
    for (let i = curIdx; i < list.length; i++) if (!list[i].hide) { currentCol = { ...list[i] }; break }
    if (!currentCol) for (let i = curIdx - 1; i > 0; i--) if (!list[i].hide) { currentCol = { ...list[i] }; break }
    let newData = { ...wndData, list, currentCol }
    setWndData(newData, true)
    setGlData({ needFocus: 0 })
  }

  const removeItemProd = () => {
    if (posted) return
    if (edit) return
    if (editProd) return
    if (!wndData.currentColProd) return
    const currCol = { ...wndData.currentColProd, edit: true, hide: true }
    const prod_list = wndData.prod_list
    const idx = prod_list.findIndex(el => el.uid === currCol.uid)
    if (idx === -1) return
    prod_list[idx] = currCol
    let curIdx = idx + 1
    let currentColProd = undefined
    for (let i = curIdx; i < prod_list.length; i++) if (!prod_list[i].hide) { currentColProd = { ...prod_list[i] }; break }
    if (!currentColProd) for (let i = curIdx - 1; i > 0; i--) if (!prod_list[i].hide) { currentColProd = { ...prod_list[i] }; break }
    const list = calculate_ing(wndData.list, prod_list)
    let newData = { ...wndData, list, prod_list, currentColProd }
    setWndData(newData, true)
    setGlData({ needFocusProd: 0 })

  }

  const calculate_ing = (list, prod_list) => {
    let new_list = []
    if (list) new_list = [...list]
    if (!catGoods) { getData('catGoods'); return new_list }
    new_list = new_list.map(el => ({ ...el, sum_qtt_p: 0, edit: (el.sum_qtt_p ? true : undefined || el.edit) }))
    if (prod_list) {
      prod_list.forEach(pr => {
        if (pr.hide) return
        const qtt_p = parseFloat(pr.sum_qtt_f || 0) - parseFloat(pr.sum_qtt_a || 0)
        const good = catGoods.find(el => el.id === pr.good.id)
        if (good && good.ingr) {
          good.ingr.forEach(ing => {
            if (parseInt(ing.type) > 1) return
            const idx = new_list.findIndex(el => el.good && el.good.id === ing.good)
            const qtt = Math.round(qtt_p * parseFloat(ing.qtt) * 1000) / 1000
            if (idx === -1) {
              const e = catGoods.find(el => el.id === ing.good)
              let qtt_a = 0
              let qtt2_a = 0
              const ib = balance.findIndex(x => x.good === parseInt(e.id))
              if (ib !== -1) {
                if (wndData.department2 && wndData.department2.id) {
                  const idx1 = balance[ib].deps.findIndex(x => parseInt(x.dep) === parseInt(wndData.department.id))
                  const idx2 = balance[ib].deps.findIndex(x => parseInt(x.dep) === parseInt(wndData.department2.id))
                  if (idx1 !== -1) qtt_a = balance[ib].deps[idx1].qtt
                  if (idx2 !== -1) qtt2_a = balance[ib].deps[idx2].qtt
                } else qtt_a = balance[ib].qtt
              }
              const item = {
                uid: uid(),
                good: { ...e },
                unit: e.unit,
                sum_qtt_p: qtt,
                sum_qtt_a: qtt_a.toFixed(3),
                sum_qtt2_a: qtt2_a.toFixed(3),
                sum_qtt2: (-qtt2_a).toFixed(3),
                edit: true
              }
              if (ib !== -1) {
                if (balance[ib].rev_date) item.rev_date = balance[ib].rev_date
                if (balance[ib].rev_qtt) item.sum_qtt_r = balance[ib].rev_qtt
              }
              if (typeof (item.unit) !== 'object') item.unit = selUnitType.find(x => x.value === item.unit)
              if (qtt !== 0) new_list.push(item)
            } else {
              new_list[idx].sum_qtt_p += qtt
              new_list[idx].edit = true
              if (new_list[idx].hide) {
                new_list[idx].hide = false
                new_list[idx].sum_qtt_f = ''
                new_list[idx].sum_qtt2_f = ''
                new_list[idx].sum_qtt2 = (-parseFloat(new_list[idx].sum_qtt_a || 0)).toFixed(3)
              }
            }
          })
        }

      })
    }
    new_list = new_list.map(el => ({
      ...el,
      sum_qtt_p: el.sum_qtt_p ? el.sum_qtt_p.toFixed(3) : '',
      sum_qtt: (parseFloat(el.sum_qtt_f || 0) + el.sum_qtt_p - parseFloat(el.sum_qtt_a || 0)).toFixed(3)
    }))
    return new_list
  }

  const info = () => {
    if (!wndData.currentCol) return
    if (!catGoods) { getData('catGoods'); return }
    const stl0 = { margin: '3px', borderBottom: '1px solid' }
    const stl1 = { display: 'inline-block', width: '300px' }
    const stl2 = { display: 'inline-block', width: '80px' }
    if (!wndData.prod_list) return
    if (!wndData.currentCol.good) return
    let ttl = 0
    let list = []
    wndData.prod_list.forEach(pr => {
      if (pr.hide) return
      const qtt_p = parseFloat(pr.sum_qtt_f || 0) - parseFloat(pr.sum_qtt_a || 0)
      const good = catGoods.find(el => el.id === pr.good.id)
      if (good && good.ingr) {
        good.ingr.forEach(ing => {
          if (parseInt(ing.type) > 1) return
          if (ing.good !== wndData.currentCol.good.id) return
          const qtt = Math.round(qtt_p * parseFloat(ing.qtt) * 1000) / 1000
          ttl += qtt
          if (qtt) {
            const idx = list.findIndex(el => el.uid === pr.uid)
            if (idx === -1) list.push({ uid: pr.uid, name: good.name, qtt })
            else list[idx].qtt += qtt
          }
        })
      }
    })
    let cont = list.map((el, idx) => (<div key={idx} style={stl0}><div style={stl1}>{el.name}</div><div style={stl2}>{el.qtt.toFixed(3) + ' ' + (wndData.currentCol.unit || { name: '' }).name}</div></div>))
    if (cont.length) cont.push(<div style={{ margin: '3px', fontWeight: 'bold' }}><div style={stl1}>{localestr('Разом')}</div><div style={stl2}>{ttl.toFixed(3) + ' ' + (wndData.currentCol.unit || { name: '' }).name}</div></div>)
    if (cont.length) msg(<div>{cont}</div>, null, [{ caption: 'OK', action: () => { } }])
  }

  const info_prod = () => {
    if (!wndData.currentColProd) return
    if (!catGoods) { getData('catGoods'); return }
    const stl0 = { margin: '3px', borderBottom: '1px solid' }
    const stl1 = { display: 'inline-block', width: '300px' }
    const stl2 = { display: 'inline-block', width: '80px' }
    const good = catGoods.find(el => el.id === wndData.currentColProd.good.id)
    if (!good) return
    if (!good.ingr) { msg(localestr('Продукт не містить інгредієнтів!'), localestr('Помилка'), [{ caption: 'OK', action: () => { } }]); return }
    const qtt_p = parseFloat(wndData.currentColProd.sum_qtt_f || 0) - parseFloat(wndData.currentColProd.sum_qtt_a || 0)
    let cont = []
    good.ingr.forEach(ing => {
      if (parseInt(ing.type) > 1) return
      const qtt = Math.round(qtt_p * parseFloat(ing.qtt) * 1000) / 1000
      const e = catGoods.find(el => el.id === ing.good)
      if (qtt && e) {
        let unit = selUnitType.find(x => x.value === e.unit)
        cont.push(<div key={cont.length} style={stl0}><div style={stl1}>{e.name}</div><div style={stl2}>{qtt.toFixed(3) + ' ' + (unit || { name: '' }).name}</div></div>)
      }
    })
    if (cont.length) msg(<div>{cont}</div>, null, [{ caption: 'OK', action: () => { } }])
  }

  const saveDoc = async (d, close = true) => {
    if ((getGlData() || {}).edit) { saveValue(() => { saveDoc(d, close) }); return }
    if ((getGlData() || {}).editProd) { saveValueProd(() => { saveDoc(d, close) }); return }
    if (d) {
      loading = false
      const status = d.status
      if (status === 'OffLine') { msg(localestr('Помилка з\'єднання'), localestr('Помилка'), [{ caption: 'OK', action: () => { } }]); return }
      if (status === 'error') { msg(d.msg, localestr('Помилка'), [{ caption: 'OK', action: () => { } }]); return }
      if (wndData.update) wndData.update(d.data)
      if (close) tabClose(false)
      else {
        let currentCol = wndData.currentCol
        let table = []
        if (d.data.table) table = d.data.table.map(el => ({ id: el.id, uid: el.uid, good_id: el.good.id, good: el.good.name, good_pid: el.good.pid, qtt_a: el.qtt_a, qtt_p: el.qtt_p, qtt_f: el.qtt_f, unit: el.unit }))

        let list = wndData.list.filter(el => !el.hide)
        let prod_list = wndData.prod_list.filter(el => !el.hide)
        list = list.map(el => ({ ...el, edit: false }))
        prod_list = prod_list.map(el => ({ ...el, edit: false }))
        /*for (let i = 0; i < list.length; i++) {
          if (!list[i].id) {
            let idx = table.findIndex(el => el.uid === list[i].uid)
            if (idx === -1) idx = table.findIndex(el => el.good_id === list[i].good.id)
            if (idx !== -1) list[i].id = table[idx].id
          }
        }
        for (let i = 0; i < prod_list.length; i++) {
          if (!prod_list[i].id) {
            let idx = table.findIndex(el => el.uid === prod_list[i].uid)
            if (idx === -1) idx = table.findIndex(el => el.good_id === prod_list[i].good.id)
            if (idx !== -1) prod_list[i].id = table[idx].id
          }
        }*/
        for (let i = 0; i < table.length; i++){
          //eslint-disable-next-line
          let idx = list.findIndex(el => el.uid === table[i].uid)
          //if (idx === -1) idx = list.findIndex(el => el.good.id === table[i].good_id)
          if (idx !== -1) list[idx].id = table[i].id
          else {
            //eslint-disable-next-line
            idx = prod_list.findIndex(el => el.uid === table[i].uid)
            //if (idx === -1) idx = prod_list.findIndex(el => el.good.id === table[i].good_id)
            if (idx !== -1) prod_list[idx].id = table[i].id
          }
        }
        table = list.map(item => ({ id: item.id, good_id: item.good.id, good: item.good.name, good_pid: item.good.parent ? item.good.parent.id : null, qtt_a: item.sum_qtt_a, qtt_p: item.sum_qtt_p, qtt_f: item.sum_qtt_f, qtt2_a: item.sum_qtt2_a, qtt2_f: item.sum_qtt2_f }))
        table = table.concat(prod_list.map(item => ({ id: item.id, good_id: item.good.id, good: item.good.name, good_pid: item.good.parent.id, qtt_a: item.sum_qtt_a, qtt_p: item.sum_qtt_p, qtt_f: item.sum_qtt_f })))
        let newData = { ...wndData, table, list, prod_list, currentCol, id: d.data.id, edit: false }
        setWndData(newData, false)
      }
    } else {
      let data = {}
      if (wndData.edit) {
        let errmsg = ''
        if (!wndData.date) errmsg += localestr("Не заповнено дату документа")
        //if (!wndData.counterpartie) errmsg+=localestr("Не заповнено контрагента")
        if (!wndData.department) errmsg += localestr("Не заповнено підрозділ")
        if (errmsg !== '') { msg(errmsg, localestr('Помилка'), [{ caption: 'OK', action: () => { } }]); return }
        if (wndData.id) data.id = wndData.id
        if (wndData.uid) data.uid = wndData.uid
        data.header = { author: wndData.author, date: wndData.date, department: wndData.department, department2: wndData.department2, article: wndData.article, note: (wndData.note || '').substring(0, 85), docum: wndData.docum }
        if (wndData.marked !== '1' && wndData.marked !== 1) data.header.act = 'post'
        if (!wndData.author) data.header.author = { id: 'NULL' }
      }
      let table = wndData.list.filter(el => el.edit).concat(wndData.prod_list.filter(el => el.edit).map(el => ({ ...el, sum_qtt_p: parseFloat(el.sum_qtt_a || 0) - parseFloat(el.sum_qtt_f || 0) })))
      table = table.filter(el => !el.hide || el.id)
      if (table.length) {
        if (wndData.id) data.id = wndData.id
        if (wndData.uid) data.uid = wndData.uid
        //if(wndData.posted) data.posted=wndData.posted
        if (wndData.marked !== '1' && wndData.marked !== 1) if (!data.header) data.header = { act: 'post' }
        data.table = table.map(el => {
          let unit = el.unit
          if (unit && unit.value) unit = unit.value
          let d = {uid: el.uid, good: { id: el.good.id, name: el.good.name, pid: el.good.parent ? el.good.parent.id : null, unit: unit }, qtt_f: el.sum_qtt_f, qtt_a: el.sum_qtt_a, qtt_p: el.sum_qtt_p, qtt2_f: el.sum_qtt2_f, qtt2_a: el.sum_qtt2_a }
          if (el.hide) d.act = 'del'
          if (el.id) d.id = el.id
          return d
        })
      }
      if (Object.keys(data).length) {
        if (parseInt(wndData.posted)) data.posted = 1
        if (parseInt(wndData.marked)) data.marked = 1
      }

      if (loading) return
      loading = true
      setTimeout(() => { loading = false }, 5000)

      if (!close) {
        if (Object.keys(data).length) {
          data.header.act = '';
          loaddata('action=modRevision&data=' + encodeURIComponent(JSON.stringify(data)), undefined, (dt) => { saveDoc(dt, close) })
        }
        return
      }
      if (Object.keys(data).length && wndData.posted && parseInt(wndData.posted) > 0) msg(localestr('Зберегти зміни?'), localestr('Збереження'), [
        { caption: 'OK', action: () => { loaddata('action=modRevision&data=' + encodeURIComponent(JSON.stringify(data)), undefined, (dt) => { saveDoc(dt) }) } },
        { caption: localestr('Відмінити'), action: () => { } }
      ])
      else if (Object.keys(data).length && (!wndData.marked || parseInt(wndData.marked) === 0)) msg(localestr('Зберегти зміни?'), localestr('Збереження'), [
        { caption: localestr('Провести'), action: () => { loaddata('action=modRevision&data=' + encodeURIComponent(JSON.stringify(data)), undefined, (dt) => { saveDoc(dt) }) } },
        { caption: localestr('Зберегти'), action: () => { data.header.act = ''; loaddata('action=modRevision&data=' + encodeURIComponent(JSON.stringify(data)), undefined, (dt) => { saveDoc(dt) }) } },
        { caption: localestr('Відмінити'), action: () => { } }
      ])
      else if ((wndData.posted === '0' || wndData.posted === 0) && (wndData.marked !== '1' && wndData.marked !== 1)) msg(localestr('Провести документ?'), localestr('Проведення'), [
        { caption: localestr('Провести'), action: () => { loaddata('action=postRevision&data=' + encodeURIComponent(JSON.stringify({ id: wndData.id })), undefined, (dt) => { saveDoc(dt) }) } },
        { caption: localestr('Відмінити'), action: () => { } }
      ])
      else if ((wndData.marked !== '1' && wndData.marked !== 1)) msg(localestr('Провести документ?'), localestr('Проведення'), [
        { caption: localestr('Закрити'), action: () => { tabClose(false) } },
        { caption: localestr('Провести'), action: () => { loaddata('action=postRevision&data=' + encodeURIComponent(JSON.stringify({ id: wndData.id })), undefined, (dt) => { saveDoc(dt) }) } }
      ])
      else if (close) tabClose(false)
    }
  }

  const recount = (d) => {
    if (posted) return
    if (d) {
      const status = d.status
      if (status === 'UsrChoise') { setLoginData(d); return }
      if (status === 'OffLine') { msg(localestr('Помилка з\'єднання'), localestr('Помилка'), [{ caption: 'OK', action: () => { } }]); return }
      if (status === 'error') { msg(d.msg, localestr('Помилка'), [{ caption: 'OK', action: () => { } }]); return }
      balance = d.data
      let newData = { ...wndData }
      let list = newData.list
      list.forEach(el => {
        if (!el.good) return
        const old_qtt_a = parseFloat(el.sum_qtt_a || 0)
        const sum_qtt_f = parseFloat(el.sum_qtt_f || 0)
        const sum_qtt_p = parseFloat(el.sum_qtt_p || 0)
        const old_qtt = parseFloat(el.sum_qtt || 0)
        let sum_qtt_a = 0
        const old_qtt2_a = parseFloat(el.sum_qtt2_a || 0)
        const sum_qtt2_f = parseFloat(el.sum_qtt2_f || 0)
        const old_qtt2 = parseFloat(el.sum_qtt2 || 0)
        let sum_qtt2_a = 0
        const idx = balance.findIndex(x => x.good === parseInt(el.good.id))
        if (idx !== -1) {
          if (balance[idx].rev_date) el.rev_date = balance[idx].rev_date
          if (balance[idx].rev_qtt) el.sum_qtt_r = balance[idx].rev_qtt
          if (wndData.department2 && wndData.department2.id) {
            const idx1 = balance[idx].deps.findIndex(x => parseInt(x.dep) === parseInt(wndData.department.id))
            const idx2 = balance[idx].deps.findIndex(x => parseInt(x.dep) === parseInt(wndData.department2.id))
            if (idx1 !== -1) sum_qtt_a = balance[idx].deps[idx1].qtt
            if (idx2 !== -1) sum_qtt2_a = balance[idx].deps[idx2].qtt
          } else sum_qtt_a = balance[idx].qtt
        }
        if (old_qtt_a.toFixed(3) !== sum_qtt_a.toFixed(3)) {
          el.sum_qtt_a = sum_qtt_a.toFixed(3)
          el.sum_qtt = (sum_qtt_f + sum_qtt_p - sum_qtt_a).toFixed(3)
          el.edit = true
        } else if (sum_qtt_f - sum_qtt_a !== old_qtt) {
          el.sum_qtt = (sum_qtt_f + sum_qtt_p - sum_qtt_a).toFixed(3)
          el.edit = true
        }
        if (old_qtt2_a.toFixed(3) !== sum_qtt2_a.toFixed(3)) {
          el.sum_qtt2_a = sum_qtt2_a.toFixed(3)
          el.sum_qtt2 = (sum_qtt2_f - sum_qtt2_a).toFixed(3)
          el.edit = true
        } else if (sum_qtt2_f - sum_qtt2_a !== old_qtt2) {
          el.sum_qtt2 = (sum_qtt2_f - sum_qtt2_a).toFixed(3)
          el.edit = true
        }
      })
      newData.list = list
      newData.balance = balance
      if (!newData.edit) newData.edit = true
      setWndData(newData, true)
    } else {
      if (wndData.department && wndData.department.id && wndData.department2 && wndData.department2.id) loaddat('action=balGoodsRev&data=' + (new Date(wndData.date)).toISOString() + '&dep=' + wndData.department.id + '-' + wndData.department2.id, (dt) => { recount(dt) })
      else if (wndData.department && wndData.department.id) loaddat('action=balGoodsRev&data=' + (new Date(wndData.date)).toISOString() + '&dep=' + wndData.department.id, (dt) => { recount(dt) })
      else loaddat('action=balGoodsRev&data=' + (new Date(wndData.date)).toISOString(), (dt) => { recount(dt) })
    }
  }

  const selectionProd = (e, qtt, qtt2) => {
    if (posted) return
    if (e.isfolder) return
    //менюшка з вибором або в константах чи локально Тихий режим, Запитувати кількість, Запитувати кількість і ціну, Запитувати кількість і суму
    if ((qtt === undefined || qtt === null) && parseInt(selectionType) > 0) {
      if (e.unit && (e.unit.value === '2' || e.unit === '2')) inputWeight(localestr('Кількість'), localestr('Кількість'), 1, (d) => { selectionProc(e, parseFloat(d || 0)) })
      else inputNumber(localestr('Кількість'), localestr('Кількість'), 1, (d) => { selectionProc(e, parseFloat(d || 0)) })
      return
    }
    if (!qtt) qtt = 0
    if (!qtt2) qtt2 = 0
    let newData = { ...wndData, findText: '', findArr: null, findTextProd: '', findArrProd: null }
    let list = newData.list
    let prod_list = newData.prod_list
    const good_type = parseInt(e.type || 1)
    if (good_type > 1) {
      let el = prod_list.find(m => m.good?.id === e.id)
      if (!el) {
        let qtt_a = 0
        let qtt2_a = 0
        const idx = balance.findIndex(x => x.good === parseInt(e.id))
        el = {
          uid: uid(),
          good: { ...e },
          unit: e.unit,
          sum_qtt_f: qtt.toFixed(3),
          sum_qtt_a: qtt_a.toFixed(3),
          sum_qtt: (qtt - qtt_a).toFixed(3),
          sum_qtt2_f: qtt2.toFixed(3),
          sum_qtt2_a: qtt2_a.toFixed(3),
          sum_qtt2: (qtt2 - qtt2_a).toFixed(3),
          product: true,
          edit: true
        }
        if (idx !== -1) {
          if (balance[idx].rev_date) el.rev_date = balance[idx].rev_date
          if (balance[idx].rev_qtt) el.sum_qtt_r = balance[idx].rev_qtt
        }
        if (typeof (el.unit) !== 'object') el.unit = selUnitType.find(x => x.value === el.unit)
        prod_list.push(el)
      } else if (el.hide) {
        const sum_qtt_f = qtt
        const sum_qtt2_f = qtt2
        const qtt_a = parseFloat(el.sum_qtt_a)
        const qtt2_a = parseFloat(el.sum_qtt2_a)
        el.sum_qtt_f = sum_qtt_f.toFixed(3)
        el.sum_qtt = (qtt - qtt_a).toFixed(3)
        el.sum_qtt2_f = sum_qtt2_f.toFixed(3)
        el.sum_qtt2 = (qtt2 - qtt2_a).toFixed(3)
        el.hide = false
        el.edit = true
      } else {
        const sum_qtt_f = parseFloat(el.sum_qtt_f || 0) + qtt
        const sum_qtt2_f = parseFloat(el.sum_qtt2_f || 0) + qtt2
        const qtt_a = parseFloat(el.sum_qtt_a)
        const qtt2_a = parseFloat(el.sum_qtt2_a)
        el.sum_qtt_f = sum_qtt_f.toFixed(3)
        el.sum_qtt = (sum_qtt_f - qtt_a).toFixed(3)
        el.sum_qtt2_f = sum_qtt2_f.toFixed(3)
        el.sum_qtt2 = (sum_qtt2_f - qtt2_a).toFixed(3)
        //el.sum_amount=''
        el.edit = true
      }
      newData.currentColProd = { ...el }
      newData.currentCol = undefined
      list = calculate_ing(list, prod_list)
    }
    newData.list = list
    newData.prod_list = prod_list
    if (newData.currFindProd !== undefined) {
      newData.currFindProd = undefined
      //Тут фокусування на пошуку 'search'
      setTimeout(() => {
        const el = document.getElementById('searchProd')
        if (el) el.focus()
      }, 200)
    }
    setWndData(newData, true)
    setGlData({ needFocusProd: -2, lastColProd: 0 })
  }

  const findItem = (val) => {
    const newData = { ...wndData, findText: val }
    findDlg = false
    newData.findArr = null
    if (val.length > 1) {
      const Arr = catGoods.filter(el => (el.id.indexOf(val) === 0 || (el.name || '').toLowerCase().indexOf(val.toLowerCase()) !== -1 || (el.barcode && el.barcode.indexOf(val) === 0)) && !parseInt(el.marked))
      if (Arr.length > 10) Arr.splice(10)
      newData.findArr = Arr
      if (Arr.length) findDlg = true
      else { newData.findArr = null; findDlg = false }
    }
    setWndData(newData)
  }

  const findItemProd = (val) => {
    const newData = { ...wndData, findTextProd: val }
    findDlgProd = false
    newData.findArrProd = null
    if (val.length > 1) {
      const Arr = catGoods.filter(el => (el.id.indexOf(val) === 0 || (el.name || '').toLowerCase().indexOf(val.toLowerCase()) !== -1 || (el.barcode && el.barcode.indexOf(val) === 0)) && !parseInt(el.marked) && parseInt(el.type) > 1)
      if (Arr.length > 10) Arr.splice(10)
      newData.findArrProd = Arr
      if (Arr.length) findDlgProd = true
      else { newData.findArrProd = null; findDlgProd = false }
    }
    setWndData(newData)
  }

  const findClick = (el) => {
    const newData = { ...wndData, findText: '', findArr: null, currFind: -1 }
    findDlg = false
    setWndData(newData)
    selectionProc({ ...el })
  }

  const findProdClick = (el) => {
    const newData = { ...wndData, findTextProd: '', findArrProd: null, currFindProd: -1 }
    findDlgProd = false
    setWndData(newData)
    selectionProd({ ...el })
  }

  const anyKey = (key) => {
    if (!isActive()) return
    if (key === 'Delete' && activeTab === 1) removeItemProd()
    else if (key === 'Delete') removeItem()
    else if (key === 'Insert' && activeTab === 1) newItemProd()
    else if (key === 'Insert') newItem()
    else if (key === 'F9') copyItem()
    else if (key === 'Escape' && activeTab === 1) cancelEditProd()
    else if (key === 'Escape') cancelEdit()
    else if (key === 'shift_F4') tabClose()
    else if (key === 'F2') filter()
  }

  const fillDoc = (ask = 1) => {
    if (posted) return
    if (!catGoods) {getData('catGoods');return}
    if (!catGoods.length) {getData('catGoods');return}
    if (wndData.list.length && ask) {
      msg(localestr('Перезаповнити залишки ?'), localestr('Збереження'), [{ caption: localestr('Так'), action: () => fillDoc(false) }, { caption: localestr('Ні'), action: () => { } }])
      return
    } else if (ask) {
      msg(localestr('Заповнити залишки ?'), localestr('Збереження'), [{ caption: localestr('Так'), action: () => fillDoc(false) }, { caption: localestr('Ні'), action: () => { } }])
      return
    }
    let list = wndData.list || []
    const prod_list = wndData.prod_list || []
    for (let i = 0; i < balance.length; i++) {
      const item = balance[i]
      let good = catGoods.find(el => parseInt(el.id) === parseInt(item.good))
      if (!good) good = { id: item.good, type: 1 }
      let idx1 = -1
      let idx2 = -1
      // eslint-disable-next-line
      if (wndData.department && wndData.department.id) idx1 = item.deps.findIndex(x => parseInt(x.dep) === parseInt(wndData.department.id))
      // eslint-disable-next-line
      if (wndData.department2 && wndData.department2.id) idx2 = item.deps.findIndex(x => parseInt(x.dep) === parseInt(wndData.department2.id))
      let idx = list.findIndex(el => parseInt(el.good.id) === parseInt(item.good))
      let idx_p = prod_list.findIndex(el => parseInt(el.good.id) === parseInt(item.good))
      if (idx !== -1) {
        const old_qtt_a = parseFloat(list[idx].sum_qtt_a || 0)
        const sum_qtt_f = parseFloat(list[idx].sum_qtt_f || 0)
        const sum_qtt_p = parseFloat(list[idx].sum_qtt_p || 0)
        const old_qtt = parseFloat(list[idx].sum_qtt || 0)
        let sum_qtt_a = 0
        const old_qtt2_a = parseFloat(list[idx].sum_qtt2_a || 0)
        const sum_qtt2_f = parseFloat(list[idx].sum_qtt2_f || 0)
        const old_qtt2 = parseFloat(list[idx].sum_qtt2 || 0)
        let sum_qtt2_a = 0
        if (idx1 !== -1) sum_qtt_a = item.deps[idx1].qtt
        if (idx2 !== -1) sum_qtt2_a = item.deps[idx2].qtt
        if (old_qtt_a.toFixed(3) !== sum_qtt_a.toFixed(3)) {
          list[idx].sum_qtt_a = sum_qtt_a.toFixed(3)
          list[idx].sum_qtt = (sum_qtt_f + sum_qtt_p - sum_qtt_a).toFixed(3)
          list[idx].edit = true
        } else if (sum_qtt_f - sum_qtt_a !== old_qtt) {
          list[idx].sum_qtt = (sum_qtt_f + sum_qtt_p - sum_qtt_a).toFixed(3)
          list[idx].edit = true
        }
        if (old_qtt2_a.toFixed(3) !== sum_qtt2_a.toFixed(3)) {
          list[idx].sum_qtt2_a = sum_qtt2_a.toFixed(3)
          list[idx].sum_qtt2 = (sum_qtt2_f - sum_qtt2_a).toFixed(3)
          list[idx].edit = true
        } else if (sum_qtt2_f - sum_qtt2_a !== old_qtt2) {
          list[idx].sum_qtt2 = (sum_qtt2_f - sum_qtt2_a).toFixed(3)
          list[idx].edit = true
        }
        if (list[idx].hide) {
          list[idx].hide = undefined
          list[idx].sum_qtt_f = ''
          list[idx].sum_qtt_p = ''
          list[idx].sum_qtt2_f = ''
          if (sum_qtt_a) { list[idx].sum_qtt_a = sum_qtt_a.toFixed(3); list[idx].sum_qtt = (-sum_qtt_a).toFixed(3); }
          if (sum_qtt2_a) { list[idx].sum_qtt2_a = sum_qtt2_a.toFixed(3); list[idx].sum_qtt2 = (-sum_qtt2_a).toFixed(3); }
        }
        if (balance[i].rev_date) list[idx].rev_date = balance[i].rev_date
        if (balance[i].rev_qtt) list[idx].sum_qtt_r = balance[i].rev_qtt
      } else if (idx_p !== -1) {
        const old_qtt_a = parseFloat(prod_list[idx_p].sum_qtt_a || 0)
        const sum_qtt_f = parseFloat(prod_list[idx_p].sum_qtt_f || 0)
        const old_qtt = parseFloat(prod_list[idx_p].sum_qtt || 0)
        let sum_qtt_a = 0
        if (idx1 !== -1) sum_qtt_a = item.deps[idx1].qtt
        if (old_qtt_a.toFixed(3) !== sum_qtt_a.toFixed(3)) {
          prod_list[idx_p].sum_qtt_a = sum_qtt_a.toFixed(3)
          prod_list[idx_p].sum_qtt = (sum_qtt_f - sum_qtt_a).toFixed(3)
          prod_list[idx_p].edit = true
        } else if (sum_qtt_f - sum_qtt_a !== old_qtt) {
          prod_list[idx_p].sum_qtt = (sum_qtt_f - sum_qtt_a).toFixed(3)
          prod_list[idx_p].edit = true
        }
        if (prod_list[idx_p].hide) {
          prod_list[idx_p].hide = undefined
          prod_list[idx_p].sum_qtt_f = ''
          prod_list[idx_p].sum_qtt2_f = ''
          if (sum_qtt_a) { prod_list[idx_p].sum_qtt_a = sum_qtt_a.toFixed(3); prod_list[idx_p].sum_qtt = (-sum_qtt_a).toFixed(3); }
        }
        if (balance[i].rev_date) prod_list[idx_p].rev_date = balance[i].rev_date
        if (balance[i].rev_qtt) prod_list[idx_p].sum_qtt_r = balance[i].rev_qtt
      } else {
        const el = { uid: uid(), good, unit: good.unit, sum_qtt_f: '', sum_qtt_a: '', sum_qtt: '', sum_qtt2_f: '', sum_qtt2_a: '', sum_qtt2: '', edit: true }
        if (typeof (el.unit) !== 'object') el.unit = selUnitType.find(x => x.value === el.unit)
        let sum_qtt_a = 0
        let sum_qtt2_a = 0
        if (idx1 !== -1) sum_qtt_a = item.deps[idx1].qtt
        if (idx2 !== -1) sum_qtt2_a = item.deps[idx2].qtt
        if (!sum_qtt_a && !sum_qtt2_a) continue
        //if(parseInt(good.type)>1&&!sum_qtt_a&&!sum_qtt2_a) continue
        if (sum_qtt_a) { el.sum_qtt_a = sum_qtt_a.toFixed(3); el.sum_qtt = (-sum_qtt_a).toFixed(3); }
        if (sum_qtt2_a) { el.sum_qtt2_a = sum_qtt2_a.toFixed(3); el.sum_qtt2 = (-sum_qtt2_a).toFixed(3); }
        if (balance[i].rev_date) el.rev_date = balance[i].rev_date
        if (balance[i].rev_qtt) el.sum_qtt_r = balance[i].rev_qtt
        /*if (parseInt(good.type) > 1) prod_list.push({ ...el, product: true })
        else */list.push(el)
      }
    }
    list = calculate_ing(list, prod_list)
    setWndData({ ...wndData, list, prod_list })
  }

  const fillRev = () => {
    const list = wndData.list || []
    const prod_list = wndData.prod_list || []
    for (let i = 0; i < balance.length; i++) {
      const item = balance[i]
      let idx = list.findIndex(el => parseInt(el.good.id) === parseInt(item.good))
      let idx_p = prod_list.findIndex(el => parseInt(el.good.id) === parseInt(item.good))
      if (idx !== -1) {
        if (balance[i].rev_date) list[idx].rev_date = balance[i].rev_date
        if (balance[i].rev_qtt) list[idx].sum_qtt_r = balance[i].rev_qtt
      } else if (idx_p !== -1) {
        if (balance[i].rev_date) prod_list[idx_p].rev_date = balance[i].rev_date
        if (balance[i].rev_qtt) prod_list[idx_p].sum_qtt_r = balance[i].rev_qtt
      }
    }
    setWndData({ ...wndData, balance, list, prod_list })
  }

  const loadData = (d, act = null) => {
    if (d) {
      loading = false
      const status = d.status
      if (status === 'OffLine') { msg(localestr('Помилка з\'єднання'), localestr('Помилка'), [{ caption: 'OK', action: () => { } }]); return }
      if (status === 'error') { msg(d.msg, localestr('Помилка'), [{ caption: 'OK', action: () => { } }]); return }
      if (d.data) balance = [...d.data]
      wndData = actions.getWndData()
      setWndData({ ...wndData, balance: d.data })
      if (act) setTimeout(() => act(), 200)
    } else if (!wndData.balance) {
      loading = true
      wndData = actions.getWndData()
      if (wndData.department && wndData.department.id && wndData.department2 && wndData.department2.id) loaddat('action=balGoodsRev&data=' + (new Date(wndData.date)).toISOString() + '&dep=' + wndData.department.id + '-' + wndData.department2.id, (dt) => { loadData(dt, act) })
      else if (wndData.department && wndData.department.id) loaddat('action=balGoodsRev&data=' + (new Date(wndData.date)).toISOString() + '&dep=' + wndData.department.id, (dt) => { loadData(dt, act) })
      //else loaddat('action=balGoodsRev&data='+(new Date(wndData.date)).toISOString(),(dt)=>{loadData(dt)})
      setTimeout(() => { loading = false }, 50)
    }
    if (!catGoods) getData('catGoods')

  }

  //--------Заповнення--------
  const fillProd = (d) => { //по випуску
    if (d) {
      console.log(d)
      if (d.tbl) {
        //d.tbl.forEach(el=>selectionProc(el,el.qtt))
        let newData = { ...wndData, findText: '', findArr: null, findTextProd: '', findArrProd: null }
        let list = newData.list
        d.tbl.forEach(e => {
          let el = list.find(m => m.good.id === e.good_id)
          let qtt = parseFloat(e.qtt)
          let qtt2 = 0
          if (!el) {
            let qtt_a = 0
            let qtt2_a = 0
            const idx = balance.findIndex(x => x.good === parseInt(e.id))
            if (idx !== -1) {
              if (wndData.department2 && wndData.department2.id) {
                const idx1 = balance[idx].deps.findIndex(x => parseInt(x.dep) === parseInt(wndData.department.id))
                const idx2 = balance[idx].deps.findIndex(x => parseInt(x.dep) === parseInt(wndData.department2.id))
                if (idx1 !== -1) qtt_a = balance[idx].deps[idx1].qtt
                if (idx2 !== -1) qtt2_a = balance[idx].deps[idx2].qtt
              } else qtt_a = balance[idx].qtt
            }
            el = {
              uid: uid(),
              good: { id: e.good_id, name: e.good },
              unit: e.unit,
              sum_qtt_f: qtt.toFixed(3),
              sum_qtt_a: qtt_a.toFixed(3),
              sum_qtt: (qtt - qtt_a).toFixed(3),
              sum_qtt2_f: qtt2.toFixed(3),
              sum_qtt2_a: qtt2_a.toFixed(3),
              sum_qtt2: (qtt2 - qtt2_a).toFixed(3),
              edit: true
            }
            if (idx !== -1) {
              if (balance[idx].rev_date) el.rev_date = balance[idx].rev_date
              if (balance[idx].rev_qtt) el.sum_qtt_r = balance[idx].rev_qtt
            }
            if (typeof (el.unit) !== 'object') el.unit = selUnitType.find(x => x.value === el.unit)
            list.push(el)
          } else if (el.hide) {
            const sum_qtt_f = qtt
            const sum_qtt2_f = qtt2
            const qtt_a = parseFloat(el.sum_qtt_a)
            const qtt2_a = parseFloat(el.sum_qtt2_a)
            el.sum_qtt_f = sum_qtt_f.toFixed(3)
            el.sum_qtt = (qtt - qtt_a).toFixed(3)
            el.sum_qtt2_f = sum_qtt2_f.toFixed(3)
            el.sum_qtt2 = (qtt2 - qtt2_a).toFixed(3)
            el.hide = false
            el.edit = true
          } else {
            const sum_qtt_f = parseFloat(el.sum_qtt_f || 0) + qtt
            const sum_qtt2_f = parseFloat(el.sum_qtt2_f || 0) + qtt2
            const qtt_a = parseFloat(el.sum_qtt_a)
            const qtt2_a = parseFloat(el.sum_qtt2_a)
            el.sum_qtt_f = sum_qtt_f.toFixed(3)
            el.sum_qtt = (sum_qtt_f - qtt_a).toFixed(3)
            el.sum_qtt2_f = sum_qtt2_f.toFixed(3)
            el.sum_qtt2 = (sum_qtt2_f - qtt2_a).toFixed(3)
            //el.sum_amount=''
            el.edit = true
          }


        })
        newData.list = list
        setWndData(newData, true)
      }
    } else addTWnd(localestr('Вибір'), 'docProduction_list', fillProd, undefined, undefined, 1)
  }

  const fillEntry = () => { //по залишках
    fillDoc(0)
  }

  const doc_print = (ask = true, prn_type = 0) => {
    //Запит на збереження
    if (wndData.edit && ask) {
      msg(localestr('Зберегти зміни перед друком?'), localestr('Збереження'), [
        { caption: localestr('Так'), action: async () => { await saveDoc(null, false); setTimeout(() => { wndData = actions.getWndData(); doc_print(false) }, 200) } },
        { caption: localestr('Ні'), action: () => { doc_print(false) } },
        { caption: localestr('Відмінити'), action: () => { } }
      ])
      return
    }
    let table = wndData.list.filter(el => el.edit)
    table = table.filter(el => !el.hide || el.id)
    if (table.length && ask) {
      msg(localestr('Зберегти зміни перед друком?'), localestr('Збереження'), [
        { caption: localestr('Так'), action: async () => { await saveDoc(null, false); setTimeout(() => { wndData = actions.getWndData(); doc_print(false) }, 200) } },
        { caption: localestr('Ні'), action: () => { doc_print(false) } },
        { caption: localestr('Відмінити'), action: () => { } }
      ])
      return
    }

    let item = { ...wndData, type: 'docRevision', prn_type }
    //console.log(item)
    //item.table=d.table.map(el=>{return{...el}})
    tabNew('docPrint', localestr('Акт інвентаризації'), item)
  }

  //----------barcode---------
  const getSymbol = (e) => {
    if (e.target.tagName === 'INPUT') return
    if (e.key === 'Insert') { newItem(); return }
    if (edit) return
    if (editProd) return
    if (e.key === 'Enter' || e.which === 13) {
      //console.log(buffer)
      if (!buffer) return
      const items = catGoods.filter(el => el.barcode === buffer)
      if (items.length) {
        buffer = ''
        if (timer) clearInterval(timer)
        timer = null
        if (items.length > 1) {
          const msg_items = items.map(el => ({ caption: (el.parent.name || '') + ' / ' + el.name, action: () => selectionProc(el) }))
          msg_arr(localestr('Виберіть товар'), '', msg_items)
        }
        selectionProc(items[0],1)
        setTimeout(() => {
          const el = document.getElementById('doc_cont')
          if (el) el.focus()
        }, 200)
      }
      buffer = ''
      if (timer) clearInterval(timer)
      timer = null
      return
    }
    buffer += e.key
    if (!timer) timer = setInterval(() => buffer = '', 500)
  }

  const objEntries = () => {
    if (wndData.id) {
      const item = { ...wndData, type: 'docRevision' }
      tabNew('repObjEntries', localestr('Проводки') + ' ' + itemToText(item), { object: item }, true)
    }
  }

  const weightClick = async () => {
    if (!edit) return
    if (!wndData.currentCol) return
    const w_type = localStorage.getItem('w_type')
    if (!w_type) {
      msg_arr(localestr('Виберіть модель ваг'), '', [{ caption: 'NT-15', action: () => { localStorage.setItem('w_type', 'NT-15'); weightClick() } }, { caption: 'Ягуар', action: () => { localStorage.setItem('w_type', 'Jaguar'); weightClick() } }])
      return
    }
    if ("serial" in navigator) {
      const ports = await navigator.serial.getPorts();
      let port = ports[0];
      if (!port) port = await navigator.serial.requestPort();
      if (w_type === 'NT-15') {
        try {
          await port.open({ baudRate: 4800, dataBits: 8, stopBits: 1, parity: 'even' });
        } catch (error) {
          console.log(error)
          return;
        }
        let timerId = setTimeout(() => port.close(), 3000)

        const writer = port.writable.getWriter();
        await writer.write(new Uint8Array([0]));
        await writer.write(new Uint8Array([0]));
        await writer.write(new Uint8Array([3]));
        writer.releaseLock();

        let w = '';

        while (port.readable) {
          const reader = port.readable.getReader({ mode: 'byob' });
          let timer2Id = setTimeout(() => reader.releaseLock(), 2000)
          try {
            while (true) {
              let buffer = new ArrayBuffer(16);
              const { value, done } = await reader.read(new Uint8Array(buffer));
              if (done) break;
              if (w.length < 6) {
                for (let i = 0; i < 6; i++) w = String.fromCharCode(value[i]) + w;
              }
              if (value.length < 8) break;
            }
          } catch (error) {
            // Handle |error|…
            console.log(error);
          } finally {
            reader.releaseLock();
            clearTimeout(timer2Id);
            await port.close();
            clearTimeout(timerId);
          }
        }
        setVal('sum_qtt_w', parseInt(w || 0) / 1000)
      } else if (w_type === 'Jaguar') {
        try {
          await port.open({ baudRate: 4800, dataBits: 8, stopBits: 1 });
        } catch (error) {
          console.log(error)
          return;
        }
        let timerId = setTimeout(() => port.close(), 3000)

        const writer = port.writable.getWriter();
        await writer.write(new Uint8Array([80]));
        writer.releaseLock();

        let w = '';

        while (port.readable) {
          const reader = port.readable.getReader({ mode: 'byob' });
          let timer2Id = setTimeout(() => reader.releaseLock(), 2000)
          try {
            while (true) {
              let buffer = new ArrayBuffer(16);
              const { value, done } = await reader.read(new Uint8Array(buffer));
              if (done) break;
              if (w.length < 6) {
                for (let i = 0; i < 6; i++) w += String.fromCharCode(value[i]);
              }
              if (value.length < 8) break;
            }
          } catch (error) {
            // Handle |error|…
            console.log(error);
          } finally {
            reader.releaseLock();
            clearTimeout(timer2Id);
            await port.close();
            clearTimeout(timerId);
          }
        }
        setVal('sum_qtt', parseFloat(w || 0))
      }
    }
  }

  const needFocus = (reset = -1) => {   //Таблиця
    const glData = getGlData() || {}
    const needFocus = glData.needFocus
    const lastCol = glData.lastCol
    if (needFocus === -2) return -2
    if (isActive() === false) return -1
    if (needFocus === undefined) return -1
    if (reset === -1) setGlData({ needFocus: -1 })
    if (reset) setGlData({ needFocus: reset })
    if (reset > 0) setGlData({ lastCol: reset })
    if (needFocus === 0 && lastCol) return lastCol
    return needFocus
  }

  const needFocusProd = (reset = -1) => {   //Таблиця
    const glData = getGlData() || {}
    const needFocusProd = glData.needFocusProd
    const lastColProd = glData.lastColProd
    if (needFocusProd === -2) return -2
    if (isActive() === false) return -1
    if (needFocusProd === undefined) return -1
    if (reset === -1) setGlData({ needFocusProd: -1 })
    if (reset) setGlData({ needFocusProd: reset })
    if (reset > 0) setGlData({ lastColProd: reset })
    if (needFocusProd === 0 && lastColProd) return lastColProd
    return needFocusProd
  }

  useEffect(() => {
    if (wndData.sorting) sortList(wndData.sorting.dataId, wndData.sorting.sort, wndData.list)
    else sortList('name', 'asc', wndData.list)
    // eslint-disable-next-line 
  }, [wndData.table])

  useEffect(() => {
    if (!loading) {
      //loading=true
      loadData(null, fillRev)
    }
    // eslint-disable-next-line 
  }, [])

  function setActive(el) {
    //це треба для сканера
    if (edit) return
    if (editProd) return
    if (!el) return
    if (document.activeElement.nodeName === 'INPUT') return
    if (document.activeElement.id === 'doc_cont') return
    if (el.contains(document.activeElement)) return
    if (document.activeElement.nodeName === 'BODY') { setTimeout(() => { setActive(el) }, 200); return }
    el.focus()
  }

  const wndDataList = typeof wndData.list === 'undefined' ? [] : wndData.list
  const sorting = typeof wndData.sorting === 'undefined' ? {} : wndData.sorting
  const showFilter = wndData.showFilter ?
    <FilterForm filterData={filterData} filter={wndData.filter} setFilter={filter} /> :
    wndData?.showFilter_prod ? <FilterForm filterData={filterData} filter={wndData.filter_prod} setFilter={filter_prod} />
      : ''  //+
  const wndProdList = typeof wndData.prod_list === 'undefined' ? [] : wndData.prod_list
  const sorting_prod = typeof wndData.sorting_prod === 'undefined' ? {} : wndData.sorting_prod

  const menuDataP = [
    { name: localestr('Друк акту'), icon: '#b503', action: () => doc_print() },
    { name: localestr('Лише мінуси'), icon: '#b503', action: () => doc_print(null, 1) },
    { name: localestr('Лише плюси'), icon: '#b503', action: () => doc_print(null, 2) },
    { name: localestr('Пустий бланк'), icon: '#b503', action: () => doc_print(null, 3) },
  ]

  const keyHandler = (e) => {
    if (e.key === 'ArrowUp' && wndData.findArr) {
      if (wndData.currFind === undefined || wndData.currFind === -1) setWndData({ ...wndData, currFind: 0 })
      else if (wndData.currFind === 0) setWndData({ ...wndData, currFind: wndData.findArr.length - 1 })
      else setWndData({ ...wndData, currFind: wndData.currFind - 1 })
    }
    else if (e.key === 'ArrowDown' && wndData.findArr) {
      if (wndData.currFind === undefined || wndData.findArr.length - 1 <= wndData.currFind) setWndData({ ...wndData, currFind: 0 })
      else setWndData({ ...wndData, currFind: wndData.currFind + 1 })
    }
    else if (e.key === 'Enter' && wndData.findArr && wndData.findArr.length) {
      if (wndData.currFind === -1 || wndData.currFind === undefined) return//findClick(wndData.findArr[0])
      e.target.blur()
      findClick(wndData.findArr[wndData.currFind])
    }
  }

  const keyHandlerProd = (e) => {
    if (e.key === 'ArrowUp' && wndData.findArrProd) {
      if (wndData.currFind === undefined || wndData.currFind === -1) setWndData({ ...wndData, currFind: 0 })
      else if (wndData.currFind === 0) setWndData({ ...wndData, currFind: wndData.findArrProd.length - 1 })
      else setWndData({ ...wndData, currFind: wndData.currFind - 1 })
    }
    else if (e.key === 'ArrowDown' && wndData.findArrProd) {
      if (wndData.currFind === undefined || wndData.findArrProd.length - 1 <= wndData.currFind) setWndData({ ...wndData, currFind: 0 })
      else setWndData({ ...wndData, currFind: wndData.currFind + 1 })
    }
    else if (e.key === 'Enter' && wndData.findArrProd && wndData.findArrProd.length) {
      if (wndData.currFind === -1 || wndData.currFind === undefined) return//findClick(wndData.findArrProd[0])
      e.target.blur()
      findProdClick(wndData.findArrProd[wndData.currFind])
    }
  }

  let findItems = null
  if (findDlg && wndData.findArr) {
    setTimeout(() => findDlg = false, 30000)
    const items = wndData.findArr.map((el, idx) => {
      let stl = { cursor: 'pointer', fontSize: 'small' }
      if (idx === wndData.currFind) stl.background = '#9E91F7'
      return (
        <div key={idx} style={stl} onClick={() => { findClick(el) }}>{(el.parent.name || '') + ' / ' + el.id + ' - ' + el.name}</div>
      )
    })
    findItems = <div className='no-print' style={{ right: '0px', top: '24px', width: '100%', position: 'absolute', background: '#FFFFFF', zIndex: '100' }}>
      {items}
    </div>
  }

  let findItemsProd = null;
  if (findDlgProd && wndData.findArrProd) {
    setTimeout(() => (findDlgProd = false), 30000);
    const items = wndData.findArrProd.map((el, idx) => {
      let stl = { cursor: 'pointer', fontSize: 'small' };
      if (idx === wndData.currFind) stl.background = '#9E91F7';
      return (
        <div key={idx} style={stl} onClick={() => findClick(el, true)}>
          {(el.parent.name || '') + ' / ' + el.id + ' - ' + el.name}
        </div>
      );
    });
    findItemsProd = (
      <div
        className="no-print"
        style={{ right: '0px', top: '24px', width: '100%', position: 'absolute', background: '#FFFFFF', zIndex: '100' }}
      >
        {items}
      </div>
    );
  }


  const repSupplies = () => {
    const to = new Date()
    let data = undefined
    if (wndData.currentCol && wndData.currentCol.good) data = {
      filter: [{ caption: 'Товар', dataId: 'good_id', typeVal: 'catGoods', compare: '=', value: wndData.currentCol.good }],
      grouping: [{ name: 'Товар', value: 'good_id', checked: false, type: 'catGoods' },
      { name: 'Група', value: 'folder_id', checked: false, type: 'fldGoods' },
      { name: 'Контрагент', value: 'counterpartie_id', checked: false, type: 'catCounterparties' },
      { name: 'Підрозділ', value: 'department_id', checked: true, type: 'catDepartments' },
      { name: 'Автор', value: 'author_id', checked: false, type: 'catUsers' },
      { name: 'Тип товару', value: 'g_type', checked: false, type: 'selGoodType' },
      { name: 'Одиниці', value: 'unit', checked: false, type: 'selUnitType' },
      { name: 'Дата', value: 'date', checked: false, type: 'date' },
      { name: 'Документ', value: 'doc_id', checked: true, type: 'document' }],
      from: beginMn(to), to: to
    }
    tabNew('repSupplies', localestr('Звіт з поступлень'), data, true)
  }

  const repSales = () => {
    const to = new Date()
    let data = undefined
    if (wndData.currentCol && wndData.currentCol.good) data = {
      filter: [{ caption: 'Меню', dataId: 'menu_id', typeVal: 'catGoods', compare: '=', value: wndData.currentCol.good }],
      grouping: [{ name: localestr('Меню'), value: 'menu_id', checked: false, type: 'catGoods' },
      { name: localestr('Група'), value: 'folder_id', checked: false, type: 'fldGoods' },
      { name: localestr('Зал'), value: 'hall_id', checked: false, type: 'catHalls' },
      { name: localestr('Стіл'), value: 'table_id', checked: false, type: 'catTables' },
      { name: localestr('Підрозділ'), value: 'department_id', checked: false, type: 'catDepartments' },
      { name: localestr('Автор'), value: 'author_id', checked: true, type: 'catUsers' },
      { name: localestr('Знижка'), value: 'discount_id', checked: false, type: 'catDiscounts' },
      { name: localestr('Тип оплати'), value: 'payType', checked: true, type: 'selPayTypes' },
      { name: localestr('Тип акцизу'), value: 'excise', checked: false, type: 'selExcise' },
      { name: localestr('РРО'), value: 'fiscal_id', checked: false, type: 'catDevices' },
      { name: localestr('Дата'), value: 'date_doc', checked: false, type: 'date' },
      { name: localestr('Документ'), value: 'doc_id', checked: true, type: 'docOrder' }],
      from: beginMn(to), to: to
    }
    tabNew('repSales', localestr('Звіт з продаж'), data, true)
  }

  const repReturn = () => {
    const to = new Date()
    let data = undefined
    if (wndData.currentCol && wndData.currentCol.good) data = {
      filter: [{ caption: 'Меню', dataId: 'menu_id', typeVal: 'catGoods', compare: '=', value: wndData.currentCol.good }],
      grouping: [{ name: localestr('Меню'), value: 'menu_id', checked: false, type: 'catGoods' },
      { name: localestr('Група'), value: 'folder_id', checked: false, type: 'fldGoods' },
      { name: localestr('Зал'), value: 'hall_id', checked: false, type: 'catHalls' },
      { name: localestr('Стіл'), value: 'table_id', checked: false, type: 'catTables' },
      { name: localestr('Підрозділ'), value: 'department_id', checked: false, type: 'catDepartments' },
      { name: localestr('Автор'), value: 'author_id', checked: true, type: 'catUsers' },
      { name: localestr('Знижка'), value: 'discount_id', checked: false, type: 'catDiscounts' },
      { name: localestr('Тип оплати'), value: 'payType', checked: true, type: 'selPayTypes' },
      { name: localestr('Тип акцизу'), value: 'excise', checked: false, type: 'selExcise' },
      { name: localestr('Причина'), value: 'reason_id', checked: true, type: 'catReasons' },
      { name: localestr('Дата'), value: 'date_doc', checked: false, type: 'date' },
      { name: localestr('Документ'), value: 'doc_id', checked: true, type: 'docOrder' }],
      from: beginMn(to), to: to
    }
    tabNew('repReturn', localestr('Звіт по відмовах'), data, true)
  }

  const repStock = () => {
    const to = new Date()
    let data = undefined
    if (wndData.currentCol && wndData.currentCol.good) data = {
      filter: [{ caption: 'Товар', dataId: 'good_id', typeVal: 'catGoods', compare: '=', value: wndData.currentCol.good }],
      grouping: [{ name: localestr('Товар'), value: 'good_id', checked: false, type: 'catGoods' },
      { name: localestr('Група'), value: 'folder_id', checked: false, type: 'fldGoods' },
      { name: localestr('Підрозділ'), value: 'department_id', checked: true, type: 'catDepartments' },
      { name: localestr('Тип товару'), value: 'g_type', checked: false, type: 'selGoodType' },
      { name: localestr('Документ'), value: 'doc_id', checked: true, type: 'document' },
      { name: localestr('Куди-Звідки'), value: 'from_to', checked: false, type: 'catalog', disable_move: true }],
      from: beginMn(to), to: to
    }
    tabNew('repStock', localestr('Звіт про залишки'), data, true)
  }

  const repCalcs = () => {
    const to = new Date()
    let data = undefined
    if (wndData.currentCol && wndData.currentCol.good) data = {
      filter: [{ caption: 'Товар', dataId: 'good_id', typeVal: 'catGoods', compare: '=', value: wndData.currentCol.good }],
      grouping: [{ name: 'Продукція', value: 'p_good_id', checked: true, type: 'catGoods' },
      { name: 'Група прод.', value: 'p_folder_id', checked: false, type: 'fldGoods' },
      { name: 'Товар', value: 'good_id', checked: false, type: 'catGoods' },
      { name: 'Група', value: 'folder_id', checked: false, type: 'fldGoods' },
      { name: 'Автор', value: 'author_id', checked: false, type: 'catUsers' },
      { name: 'Тип товару', value: 'g_type', checked: false, type: 'selGoodType' },
      { name: 'Одиниці', value: 'unit', checked: false, type: 'selUnitType' },
      { name: 'Дата', value: 'date', checked: false, type: 'date' },
      { name: 'Документ', value: 'doc_id', checked: true, type: 'document' }],
      to: to, run: true
    }
    tabNew('repCalcs', localestr('Звіт по калькуляціях'), data, true)
  }


  const repData = [
    { name: localestr('Прихід'), icon: '#b230', action: repSupplies },
    { name: localestr('Продажі'), icon: '#b230', action: repSales },
    { name: localestr('Відмови'), icon: '#b230', action: repReturn },
    { name: localestr('Залишки'), icon: '#b230', action: repStock },
    { name: localestr('Де використовується'), icon: '#b230', action: repCalcs },
  ]

  const menuDataF = [
    { name: localestr('По папці'), icon: '#b201', action: () => { selectionClick(3) } },
    { name: localestr('По випуску'), icon: '#b300', action: () => { fillProd() } },
    { name: localestr('По залишках'), icon: '#b104', action: () => { fillEntry() } },
  ]

  const menuData = [
    { name: localestr('Налаштування таблиці'), icon: '#b953', action: () => setHidenCols(null, false) },
    { name: localestr('Фільтр'), icon: '#b955', action: filter },
    { name: localestr('Проводки документа'), icon: '#postBut', action: objEntries },
  ];

  const menuData_prod = [
    { name: localestr('Налаштування таблиці'), icon: '#b953', action: () => setHidenCols(null, true) },
    { name: localestr('Фільтр'), icon: '#b955', action: filter_prod },
  ];

  let weightBtn = null
  //if(wndData.currentCol && wndData.currentCol.good && wndData.currentCol.good.unit && parseInt(wndData.currentCol.good.unit.value)===2) weightBtn=
  if (edit && wndData.currentCol && wndData.currentCol.unit && parseInt(wndData.currentCol.unit.value) === 2) weightBtn =
    <div id='modal' tabIndex='0' onClick={() => { weightClick() }} onKeyUp={(e) => { if (e.key === 'Enter') weightClick() }}
      style={{ alignSelf: 'center', lineHeight: '30px', height: '30px', width: '95px', padding: '0px 2px 0 6px', color: '#FFF', userSelect: 'none', cursor: 'pointer', background: 'url(' + icon + '#btn95v) no-repeat', backgroundSize: '103px 30px' }}>
      <img style={{ width: '12px', height: '24px', verticalAlign: 'middle', marginLeft: '12px', marginRight: '8px' }} src={icon + '#run'} alt={localestr('Вага')} />
      {localestr('Вага')}
    </div>

  //let min_height=window.innerHeight-270
  //if(wndData.p_head||wndData.p_head===undefined) min_height-=63
  //if(wndData.p_prod||(wndData.p_prod===undefined&&wndProdList.length)) min_height-=Math.min(232,wndProdList.length*30+92)

  if (window.innerWidth < 425) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', margin: '4px 5px 0 5px', height: 'calc(100% - 30px)', outline: 'none', width: 'calc(100% - 10px)' }} tabIndex='0' id='doc_cont'
        ref={el => { setActive(el); return targetRef }} onKeyUp={getSymbol}>
        <div style={{ margin: '2px 0', display: 'inherit', flexDirection: 'column', gap: '10px' }}>
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <EditCtrl Capt={localestr('Інвентаризація') + ' №'} Value={wndData.id} typeVal={'text'} setVal={(d) => { setValue('id', d) }} width1='90' width2='1' disabled={true} />
            <div style={{ minWidth: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '10px' }}></div>
            <EditCtrl Capt={localestr('від')} title={localestr('На яку дату та час зафіксовані залишки. Програма розраховує залишки по обліку саме на цей момент.')}
              disabled={posted} Value={new Date(wndData.date)} typeVal={'datetime'} setVal={(d) => { setValue('date', d) }} width1='20' width2='45' />
          </div>

          <EditCtrl Capt={localestr('Основний підрозділ')} title={localestr('Підрозділ, на якому проводиться інвентаризація. Залишки розраховуються по вказаному підрозділу')}
            disabled={posted} Value={wndData.department} typeVal={'catDepartments'} setVal={(d) => { setValue('department', d) }} width1='135' width2='20' />
        </div>
        <Panel caption={''} width={165} open={wndData.p_head === undefined ? true : wndData.p_head} setOpen={d => setWndData({ ...wndData, p_head: d })}>
          <div style={{ margin: '2px 0', display: 'inherit', flexDirection: 'column' }}>
            <EditCtrl Capt={localestr('Додатковий підрозділ')} title={localestr('Можна знімати залишки одразу на двох підрозділах. Наприклад Бар та Алкоголь')}
              disabled={posted} Value={wndData.department2} typeVal={'catDepartments'} setVal={(d) => { setValue('department2', d) }} width1='164' width2='20' />
            <div style={{ minWidth: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
            <EditCtrl Capt={localestr('Стаття витрат')} title={localestr('На якій статті у звіті про прибутки/збитки буде відображено результат інвентаризації')}
              disabled={posted} Value={wndData.article} typeVal={'catArticles'} setVal={(d) => { setValue('article', d) }} width1='100' width2='260' />
          </div>
          <div style={{ marginBottom: '5px' }}>
            <EditCtrl Capt={localestr('Примітка')} disabled={posted} Value={wndData.note} typeVal={'text'} setVal={(d) => { setValue('note', d) }} width1='70' width2='250' />
          </div>
        </Panel>


        <div style={{ display: 'flex' }}>
          <button onClick={() => setActiveTab(0)}
            className={`tabbuton ${activeTab === 0 && "active"}`}
            style={{ maxWidth: "250px", padding: "0px" }}>{localestr('Товари та інгредієнти')}</button>
          <button onClick={() => setActiveTab(1)}
            className={`tabbuton ${activeTab === 1 && "active"}`}
            style={{ maxWidth: "250px", padding: "0px" }}>{localestr('Продукція та напівфабрикати')}</button>
        </div>
        <div style={{ display: activeTab === 0 ? 'inherit' : 'none', flexDirection: 'column', height: '100%', overflow: 'hidden' }}>
          <div className='toolBar no-print'>
            <div tabIndex='0' className='toolBarItem' title={localestr('Додати') + ' (Ins)'}
              onClick={() => newItem()}
              onKeyUp={(e) => { if (e.key === 'Enter') newItem() }}><img src={icon + '#addBut'} alt={localestr('Додати')} /></div>

            <div tabIndex='0' className='toolBarItem' title={localestr('Видалити') + ' (Del)'}
              onClick={() => removeItem()}
              onKeyUp={(e) => { if (e.key === 'Enter') removeItem() }}><img src={icon + '#delBut'} alt={localestr('Видалити')} /></div>

            <div tabIndex='0' className='toolBarItem' title={localestr('Автофільтр')}
              onClick={() => showHideFilter()}
              onKeyUp={(e) => { if (e.key === 'Enter') showHideFilter() }}><img src={icon + '#filtBut'} alt={localestr('Автофільтр')} /></div>
            {weightBtn}

            <div tabIndex='0' onClick={() => { selectionClick(3) }} onKeyUp={(e) => { if (e.key === 'Enter') selectionClick(3) }}
              style={{ alignSelf: 'center', lineHeight: '30px', height: '30px', width: '94px', padding: '0px 2px 0 6px', color: '#FFF', userSelect: 'none', cursor: 'pointer', background: 'url(' + icon + '#btn95v) no-repeat', backgroundSize: '102px 30px' }}>
              <img style={{ width: '24px', height: '24px', verticalAlign: 'middle' }} src={icon + '#sel'} alt={localestr('Підбір')} />&nbsp;
              {localestr('Підбір')}
            </div>
            <div tabIndex='0' className='toolBarSeparator'></div>
            <div style={{ position: 'relative', padding: '3px' }}>
              <input id='search' type='text' value={wndData.findText || ''} onChange={(e) => { findItem(e.target.value) }} onKeyUp={keyHandler}
                onBlur={() => { setTimeout(() => { if (findDlg) setWndData({ ...wndData, findArr: null, currFind: undefined }) }, 200) }} placeholder={localestr('пошук')}
                style={{ width: 'calc(100% - 28px)', padding: '0 22px 0 2px', flexShrink: '0', fontSize: 'inherit', fontFamily: 'inherit' }} />
              <img src={icon + '#b956'} alt='' style={{ position: 'absolute', right: '7px', top: '9px', width: '14px', height: '14px', opacity: 0.5 }} />
              {findItems}
            </div>
            <div tabIndex='0' className='toolBarItem' title={localestr('Інформація про перерахунки')}
              onClick={() => info()}
              onKeyUp={(e) => { if (e.key === 'Enter') info() }}><img src={icon + '#info'} alt={localestr('Інформація про перерахунки')} /></div>
            <div tabIndex='0' className='toolBarSeparator'></div>
            <Menu data={menuDataF}><div tabIndex='0' style={{ alignSelf: 'center', lineHeight: '30px', height: '30px', width: '95px', padding: '0px 2px 0 6px', color: '#FFF', userSelect: 'none', cursor: 'pointer', background: 'url(' + icon + '#btn95v) no-repeat', backgroundSize: '102px 30px' }}>
              &nbsp;
              {localestr('Заповнити')}
            </div></Menu>
            <div style={{ flexGrow: '10' }}></div>
            <Menu data={repData}><div tabIndex='0' style={{ alignSelf: 'center', lineHeight: '30px', height: '30px', width: '95px', padding: '0px 2px 0 6px', color: '#FFF', userSelect: 'none', cursor: 'pointer', background: 'url(' + icon + '#btn95v) no-repeat', backgroundSize: '102px 30px' }}>
              <img style={{ width: '24px', height: '24px', verticalAlign: 'middle', paddingRight: '8px' }} src={icon + '#rep'} alt={localestr('Звіти')} />&nbsp;
              {localestr('Звіти')}
            </div></Menu>
            <div className='toolBarItem' title={localestr('Додатково')}><Menu data={menuData}>
              <img className='toolBarIcon' src={icon + '#dnBut'} alt='' />
            </Menu></div>
          </div>
          <UniTable haveHeader={true} colsArr={cols} data={wndDataList} currCol={{ ...wndData.currentCol, edit: isActive2 }} sorting={sorting} filter={wndData.filter} filtArr={filterData} showFilter={wndData.showAFilter} clickSort={sortList} clickHandle={(item) => { setCol(item) }} openHandle={editClick} keyHandle={anyKey} saveHandle={saveValue} cancelHandle={cancelEdit} setFilter={setFilter} tblPos={tblPos} needFocus={needFocus} />
        </div>
        <div style={{ display: activeTab === 1 ? 'inherit' : 'none', flexDirection: 'column', height: '100%', overflow: 'hidden' }}>
          <div className='toolBar no-print'>
            <div tabIndex='0' className='toolBarItem' title={localestr('Додати') + ' (Shift+Ins)'}
              onClick={() => newItemProd()}
              onKeyUp={(e) => { if (e.key === 'Enter') newItemProd() }}><img src={icon + '#addBut'} alt={localestr('Додати')} /></div>

            <div tabIndex='0' className='toolBarItem' title={localestr('Видалити') + ' (Shift+Del)'}
              onClick={() => removeItemProd()}
              onKeyUp={(e) => { if (e.key === 'Enter') removeItemProd() }}><img src={icon + '#delBut'} alt={localestr('Видалити')} /></div>
            <div tabIndex="0" className="toolBarItem" title={localestr("Автофільтр")} onClick={() => showHideFilter(true)} onKeyUp={(e) => { if (e.key === "Enter") showHideFilter(true); }}>
              <img src={icon + "#filtBut"} alt={localestr("Автофільтр")} />
            </div>

            <div style={{ position: 'relative', padding: '3px' }}>
              <input id='searchProd' type='text' value={wndData.findTextProd || ''} onChange={(e) => { findItemProd(e.target.value) }} onKeyUp={keyHandlerProd}
                onBlur={() => { setTimeout(() => { if (findDlgProd) setWndData({ ...wndData, findArrProd: null, currFindProd: undefined }) }, 200) }} placeholder={localestr('пошук')}
                style={{ width: 'calc(100% - 28px)', padding: '0 22px 0 2px', flexShrink: '0', fontSize: 'inherit', fontFamily: 'inherit' }} />
              <img src={icon + '#b956'} alt='' style={{ position: 'absolute', right: '7px', top: '9px', width: '14px', height: '14px', opacity: 0.5 }} />
              {findItemsProd}
            </div>

            <div tabIndex='0' className='toolBarItem' title={localestr('Інформація про перерахунки')}
              onClick={() => info_prod()}
              onKeyUp={(e) => { if (e.key === 'Enter') info_prod() }}><img src={icon + '#info'} alt={localestr('Інформація про перерахунки')} /></div>
            <div style={{ flexGrow: '10' }}></div>

            <div className='toolBarItem' title={localestr('Додатково')}><Menu data={menuData_prod}>
              <img className='toolBarIcon' src={icon + '#dnBut'} alt='' />
            </Menu></div>
          </div>
          <UniTable haveHeader={true} colsArr={cols_prod} data={wndProdList} currCol={{ ...wndData.currentColProd, edit: isActive2 }} sorting={sorting_prod} filter={wndData.filter_prod} filtArr={filterData} showFilter={wndData.showAFilter_prod} clickSort={sortList_prod} clickHandle={(item) => { setColProd(item) }} openHandle={editItemProd} keyHandle={anyKey} saveHandle={saveValueProd} cancelHandle={cancelEditProd} setFilter={setFilter_prod} tblPos={tblPosProd} needFocus={needFocusProd} />
        </div>

        <div className='no-print'>
          <div style={{ margin: '2px 0', display: 'inherit' }}>
            <div style={{ width: '80px', display: 'inline-block', verticalAlign: 'bottom' }} className={'key_btn'} onClick={() => saveDoc()}><div style={{ height: '30px', lineHeight: '30px', display: 'block' }}>OK</div></div>
            <div style={{ width: '100px', display: 'inline-block', verticalAlign: 'bottom' }} className={'key_btn'} onClick={() => saveDoc(null, false)}><div style={{ height: '30px', lineHeight: '30px', display: 'block' }}>{localestr('Зберегти')}</div></div>
            <div style={{ width: '170px', display: 'inline-block', verticalAlign: 'bottom' }} className={'key_btn'} onClick={() => recount()}><div style={{ height: '30px', lineHeight: '30px', display: 'block' }}>{localestr('Оновити облік. к-сть')}</div></div>
            <div style={{ width: '70px', display: 'inline-block', verticalAlign: 'bottom', overflow: 'visible' }} className={'key_btn'}><div style={{ height: '30px', lineHeight: '30px', display: 'block' }}><Menu stl={{}} data={menuDataP} left={true} bottom={true}>{localestr('Друк')}</Menu></div></div>
          </div>
          {showFilter}
        </div>
      </div>
    )
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', margin: '4px 0', height: 'calc(100% - 10px)', outline: 'none', width: 'calc(100% - 6px)' }} tabIndex='0' id='doc_cont'
      ref={el => { setActive(el); return targetRef }} onKeyUp={getSymbol}>
      <div style={{ margin: '2px 0', display: 'inherit' }}>
        <EditCtrl Capt={localestr('Інвентаризація') + ' №'} Value={wndData.id} typeVal={'text'} setVal={(d) => { setValue('id', d) }} width1='136' width2='36' disabled={true} />
        <div style={{ minWidth: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
        <EditCtrl Capt={localestr('від')} title={localestr('На яку дату та час зафіксовані залишки. Програма розраховує залишки по обліку саме на цей момент.')}
          disabled={posted} Value={new Date(wndData.date)} typeVal={'datetime'} setVal={(d) => { setValue('date', d) }} width1='24' width2='168' />
        <div style={{ minWidth: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
        <EditCtrl Capt={localestr('Основний підрозділ')} title={localestr('Підрозділ, на якому проводиться інвентаризація. Залишки розраховуються по вказаному підрозділу')}
          disabled={posted} Value={wndData.department} typeVal={'catDepartments'} setVal={(d) => { setValue('department', d) }} width1='148' width2='260' />
      </div>
      <Panel caption={''} width={792} open={wndData.p_head === undefined ? true : wndData.p_head} setOpen={d => setWndData({ ...wndData, p_head: d })}>
        <div style={{ margin: '2px 0', display: 'inherit' }}>
          <EditCtrl Capt={localestr('Додатковий підрозділ')} title={localestr('Можна знімати залишки одразу на двох підрозділах. Наприклад Бар та Алкоголь')}
            disabled={posted} Value={wndData.department2} typeVal={'catDepartments'} setVal={(d) => { setValue('department2', d) }} width1='164' width2='260' />
          <div style={{ minWidth: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
          <EditCtrl Capt={localestr('Стаття витрат')} title={localestr('На якій статті у звіті про прибутки/збитки буде відображено результат інвентаризації')}
            disabled={posted} Value={wndData.article} typeVal={'catArticles'} setVal={(d) => { setValue('article', d) }} width1='100' width2='260' />
        </div>
        <EditCtrl Capt={localestr('Примітка')} disabled={posted} Value={wndData.note} typeVal={'text'} setVal={(d) => { setValue('note', d) }} width1='70' width2='722' />
      </Panel>

      <div style={{ display: 'flex' }}>
        <button onClick={() => setActiveTab(0)}
          className={`tabbuton ${activeTab === 0 && "active"}`}
          style={{ maxWidth: "250px", padding: "0px" }}>{localestr('Товари та інгредієнти')}</button>
        <button onClick={() => setActiveTab(1)}
          className={`tabbuton ${activeTab === 1 && "active"}`}
          style={{ maxWidth: "250px", padding: "0px" }}>{localestr('Продукція та напівфабрикати')}</button>
      </div>
      <div style={{ display: activeTab === 0 ? 'inherit' : 'none', flexDirection: 'column', height: '100%', overflow: 'hidden' }}>
        <div className='toolBar no-print'>
          <div tabIndex='0' className='toolBarItem' title={localestr('Додати') + ' (Ins)'}
            onClick={() => newItem()}
            onKeyUp={(e) => { if (e.key === 'Enter') newItem() }}><img src={icon + '#addBut'} alt={localestr('Додати')} /></div>

          <div tabIndex='0' className='toolBarItem' title={localestr('Видалити') + ' (Del)'}
            onClick={() => removeItem()}
            onKeyUp={(e) => { if (e.key === 'Enter') removeItem() }}><img src={icon + '#delBut'} alt={localestr('Видалити')} /></div>

          <div tabIndex='0' className='toolBarItem' title={localestr('Автофільтр')}
            onClick={() => showHideFilter()}
            onKeyUp={(e) => { if (e.key === 'Enter') showHideFilter() }}><img src={icon + '#filtBut'} alt={localestr('Автофільтр')} /></div>
          {weightBtn}

          <div tabIndex='0' onClick={() => { selectionClick(3) }} onKeyUp={(e) => { if (e.key === 'Enter') selectionClick(3) }}
            style={{ alignSelf: 'center', lineHeight: '30px', height: '30px', width: '94px', padding: '0px 2px 0 6px', color: '#FFF', userSelect: 'none', cursor: 'pointer', background: 'url(' + icon + '#btn95v) no-repeat', backgroundSize: '102px 30px' }}>
            <img style={{ width: '24px', height: '24px', verticalAlign: 'middle' }} src={icon + '#sel'} alt={localestr('Підбір')} />&nbsp;
            {localestr('Підбір')}
          </div>
          <div tabIndex='0' className='toolBarSeparator'></div>
          <div style={{ position: 'relative', padding: '3px' }}>
            <input id='search' type='text' value={wndData.findText || ''} onChange={(e) => { findItem(e.target.value) }} onKeyUp={keyHandler}
              onBlur={() => { setTimeout(() => { if (findDlg) setWndData({ ...wndData, findArr: null, currFind: undefined }) }, 200) }} placeholder={localestr('пошук')}
              style={{ width: 'calc(100% - 28px)', padding: '0 22px 0 2px', flexShrink: '0', fontSize: 'inherit', fontFamily: 'inherit' }} />
            <img src={icon + '#b956'} alt='' style={{ position: 'absolute', right: '7px', top: '9px', width: '14px', height: '14px', opacity: 0.5 }} />
            {findItems}
          </div>
          <div tabIndex='0' className='toolBarItem' title={localestr('Інформація про перерахунки')}
            onClick={() => info()}
            onKeyUp={(e) => { if (e.key === 'Enter') info() }}><img src={icon + '#info'} alt={localestr('Інформація про перерахунки')} /></div>
          <div tabIndex='0' className='toolBarSeparator'></div>
          <Menu data={menuDataF}><div tabIndex='0' style={{ alignSelf: 'center', lineHeight: '30px', height: '30px', width: '95px', padding: '0px 2px 0 6px', color: '#FFF', userSelect: 'none', cursor: 'pointer', background: 'url(' + icon + '#btn95v) no-repeat', backgroundSize: '102px 30px' }}>
            &nbsp;
            {localestr('Заповнити')}
          </div></Menu>
          <div style={{ flexGrow: '10' }}></div>
          <Menu data={repData}><div tabIndex='0' style={{ alignSelf: 'center', lineHeight: '30px', height: '30px', width: '95px', padding: '0px 2px 0 6px', color: '#FFF', userSelect: 'none', cursor: 'pointer', background: 'url(' + icon + '#btn95v) no-repeat', backgroundSize: '102px 30px' }}>
            <img style={{ width: '24px', height: '24px', verticalAlign: 'middle', paddingRight: '8px' }} src={icon + '#rep'} alt={localestr('Звіти')} />&nbsp;
            {localestr('Звіти')}
          </div></Menu>
          <div className='toolBarItem' title={localestr('Додатково')}><Menu data={menuData}>
            <img className='toolBarIcon' src={icon + '#dnBut'} alt='' />
          </Menu></div>
        </div>
        <UniTable haveHeader={true} colsArr={cols} data={wndDataList} currCol={{ ...wndData.currentCol, edit: isActive2 }} sorting={sorting} filter={wndData.filter} filtArr={filterData} showFilter={wndData.showAFilter} clickSort={sortList} clickHandle={(item) => { setCol(item) }} openHandle={editClick} keyHandle={anyKey} saveHandle={saveValue} cancelHandle={cancelEdit} setFilter={setFilter} tblPos={tblPos} needFocus={needFocus} />
      </div>
      <div style={{ display: activeTab === 1 ? 'inherit' : 'none', flexDirection: 'column', height: '100%', overflow: 'hidden' }}>
        <div className='toolBar no-print'>
          <div tabIndex='0' className='toolBarItem' title={localestr('Додати') + ' (Shift+Ins)'}
            onClick={() => newItemProd()}
            onKeyUp={(e) => { if (e.key === 'Enter') newItemProd() }}><img src={icon + '#addBut'} alt={localestr('Додати')} /></div>

          <div tabIndex='0' className='toolBarItem' title={localestr('Видалити') + ' (Shift+Del)'}
            onClick={() => removeItemProd()}
            onKeyUp={(e) => { if (e.key === 'Enter') removeItemProd() }}><img src={icon + '#delBut'} alt={localestr('Видалити')} /></div>
          <div tabIndex="0" className="toolBarItem" title={localestr("Автофільтр")} onClick={() => showHideFilter(true)} onKeyUp={(e) => { if (e.key === "Enter") showHideFilter(true); }}>
            <img src={icon + "#filtBut"} alt={localestr("Автофільтр")} />
          </div>

          <div style={{ position: 'relative', padding: '3px' }}>
            <input id='searchProd' type='text' value={wndData.findTextProd || ''} onChange={(e) => { findItemProd(e.target.value) }} onKeyUp={keyHandlerProd}
              onBlur={() => { setTimeout(() => { if (findDlgProd) setWndData({ ...wndData, findArrProd: null, currFindProd: undefined }) }, 200) }} placeholder={localestr('пошук')}
              style={{ width: 'calc(100% - 28px)', padding: '0 22px 0 2px', flexShrink: '0', fontSize: 'inherit', fontFamily: 'inherit' }} />
            <img src={icon + '#b956'} alt='' style={{ position: 'absolute', right: '7px', top: '9px', width: '14px', height: '14px', opacity: 0.5 }} />
            {findItemsProd}
          </div>

          <div tabIndex='0' className='toolBarItem' title={localestr('Інформація про перерахунки')}
            onClick={() => info_prod()}
            onKeyUp={(e) => { if (e.key === 'Enter') info_prod() }}><img src={icon + '#info'} alt={localestr('Інформація про перерахунки')} /></div>
          <div style={{ flexGrow: '10' }}></div>

          <div className='toolBarItem' title={localestr('Додатково')}><Menu data={menuData_prod}>
            <img className='toolBarIcon' src={icon + '#dnBut'} alt='' />
          </Menu></div>
        </div>
        <UniTable haveHeader={true} colsArr={cols_prod} data={wndProdList} currCol={{ ...wndData.currentColProd, edit: isActive2 }} sorting={sorting_prod} filter={wndData.filter_prod} filtArr={filterData} showFilter={wndData.showAFilter_prod} clickSort={sortList_prod} clickHandle={(item) => { setColProd(item) }} openHandle={editItemProd} keyHandle={anyKey} saveHandle={saveValueProd} cancelHandle={cancelEditProd} setFilter={setFilter_prod} tblPos={tblPosProd} needFocus={needFocusProd} />
      </div>

      <div className='no-print'>
        <div style={{ margin: '2px 0', display: 'inherit' }}>
          <div style={{ width: '80px', display: 'inline-block', verticalAlign: 'bottom' }} className={'key_btn'} onClick={() => saveDoc()}><div style={{ height: '30px', lineHeight: '30px', display: 'block' }}>OK</div></div>
          <div style={{ width: '100px', display: 'inline-block', verticalAlign: 'bottom' }} className={'key_btn'} onClick={() => saveDoc(null, false)}><div style={{ height: '30px', lineHeight: '30px', display: 'block' }}>{localestr('Зберегти')}</div></div>
          <div style={{ width: '170px', display: 'inline-block', verticalAlign: 'bottom' }} className={'key_btn'} onClick={() => recount()}><div style={{ height: '30px', lineHeight: '30px', display: 'block' }}>{localestr('Оновити облік. к-сть')}</div></div>
          <div style={{ width: '70px', display: 'inline-block', verticalAlign: 'bottom', overflow: 'visible' }} className={'key_btn'}><div style={{ height: '30px', lineHeight: '30px', display: 'block' }}><Menu stl={{}} data={menuDataP} left={true} bottom={true}>{localestr('Друк')}</Menu></div></div>
        </div>
        {showFilter}
      </div>
    </div>
  )

}

export default DocRevisionEdit